(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  function stripHtml(html) {
    if (!html) return '';
    var el = document.createElement('div');
    el.innerHTML = String(html);
    return el.textContent || el.innerText || '';
  }

  function normalizeDesignToken(token) {
    var str = String(token || '');
    if (typeof theme !== 'undefined' && typeof theme.normalizeBuilderLetters === 'function') {
      return theme.normalizeBuilderLetters(str);
    }
    return str.replace(/\u271D\uFE0F?/g, '\u2020').replace(/\u2721\uFE0F?/g, '\u2020');
  }

  function formatMoney(cents, moneyFormat) {
    var amount = Number(cents) || 0;
    var formatted;
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      formatted = Shopify.formatMoney(amount, moneyFormat);
    } else {
      formatted = '£' + (amount / 100).toFixed(2);
    }
    return stripHtml(formatted);
  }

  function countCharmsForVariant(selectedCharms, variantId) {
    return selectedCharms.filter(function (c) {
      return c && Number(c.id) === Number(variantId);
    }).length;
  }

  var EXCLUDED_CHARM_LABELS = {
    'end cap': true,
    'end caps': true,
    'spacer': true,
    'spacers': true
  };

  function isExcludedCharmLabel(label) {
    return EXCLUDED_CHARM_LABELS[String(label || '').trim().toLowerCase()] === true;
  }

  function parseInventoryQuantity(value) {
    var parsed = parseInt(String(value), 10);
    if (isNaN(parsed)) return null;
    return parsed;
  }

  function configureBuilderImage(img) {
    img.draggable = false;
    img.addEventListener('dragstart', function (event) {
      event.preventDefault();
    });
    return img;
  }

  function generateBuilderId() {
    if (typeof crypto !== 'undefined' && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return 'builder-' + Date.now() + '-' + Math.random().toString(36).slice(2, 9);
  }

  function parsePositiveInt(value) {
    if (value === null || value === undefined || value === '') return null;
    var parsed = parseInt(String(value), 10);
    if (isNaN(parsed) || parsed < 0) return null;
    return parsed;
  }

  function parseBootstrap() {
    var el = document.getElementById('product-builder-bootstrap');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.error('[ProductBuilder] Failed to parse bootstrap JSON', e);
      return null;
    }
  }

  var BUILDER_ADD_TO_BAG_SPINNER =
    '<svg style="margin-top:2px" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="16px" height="16px" viewBox="0 0 16 16">' +
      '<g transform="translate(0, 0)"><g class="nc-loop-circle-3-16-icon-f">' +
        '<path d="M8 16a8 8 0 1 1 8-8 1 1 0 0 1-2 0 6 6 0 1 0-1.8 4.286 1 1 0 1 1 1.4 1.428A7.956 7.956 0 0 1 8 16z" fill="#ffffff"></path>' +
      '</g>' +
      '<style>.nc-loop-circle-3-16-icon-f{--animation-duration:0.7s;transform-origin:8px 8px;animation:nc-loop-circle-3-anim var(--animation-duration) infinite linear}@keyframes nc-loop-circle-3-anim{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}</style>' +
    '</g></svg>';

  function setAddToBagButtonLoading(btn, isLoading, label) {
    if (!btn) return;

    if (isLoading) {
      if (!btn.dataset.builderDefaultLabel) {
        btn.dataset.builderDefaultLabel = label || btn.textContent.trim();
      }
      btn.disabled = true;
      btn.innerHTML = BUILDER_ADD_TO_BAG_SPINNER;
      return;
    }

    btn.disabled = false;
    btn.textContent = label || btn.dataset.builderDefaultLabel || 'Add to bag';
  }

  function ProductBuilder(root, data) {
    this.root = root;
    this.data = data;
    this.config = data.config || {};
    this.placement = this.config.placement || {};
    this.normalizePlacementConfig();
    this.charmGroups = data.charm_groups || [];
    this.charmGroup = this.charmGroups[0] || null;
    this.charmTiles = [];
    this.cartVariantCounts = {};
    this.selectedCharms = [];
    this.builderId = null;
    this.step = 'product';
    this.baseVariantId = this.getInitialVariantId();
    this.dragFromIndex = null;
    this.dragInsertIndex = null;
    this.draggingEl = null;
    this.dropPlaceholder = null;
    this.dropEndPlaceholder = null;
    this.dragCloneEl = null;
    this.dragPointerId = null;
    this.dragActive = false;
    this.dragItemRects = null;
    this.previewCharmStates = {};
    this.activePreviewLayout = null;
    this.scrollLockActive = false;
    this.scrollLockScrollY = 0;
    this.scrollbarGap = 0;
    this.panelTransitionTimer = null;
    this.previewLayoutSwitchTimer = null;
    this.previewLayoutSwitchPreload = null;
    this.previewLayoutThumbActive = 'a';
    this.previewZoomOpen = false;
    this.previewZoomTransform = null;
    this.previewZoomGesturesBound = false;
    this.pendingEngraveTile = null;
    this.charmSelectorInputTimer = null;
    this.baseImagePreloadCache = {};
    this.previewRenderToken = 0;
    this.supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    this.els = {
      launch: document.querySelector('[data-builder-launch]'),
      workspace: root.querySelector('.product-builder__workspace'),
      baseImage: root.querySelector('[data-builder-base-image]'),
      charmsLayer: root.querySelector('[data-builder-charms-layer]'),
      charmGrid: root.querySelector('[data-builder-charm-grid]'),
      charmSelector: root.querySelector('[data-builder-charm-selector]'),
      charmSelectorInput: root.querySelector('[data-builder-charm-selector-input]'),
      charmSelectorMax: root.querySelector('[data-builder-charm-selector-max]'),
      panelChoose: root.querySelector('[data-builder-panel-choose]'),
      panelReview: root.querySelector('[data-builder-panel-review]'),
      panelStack: root.querySelector('.product-builder__panel-stack'),
      panelTitle: root.querySelector('[data-builder-panel-title]'),
      complementaryNote: root.querySelector('[data-builder-complementary-note]'),
      bespokeCharms: root.querySelector('[data-builder-bespoke-charms]'),
      bespokeCharmsToggle: root.querySelector('[data-builder-bespoke-charms-toggle]'),
      bespokeCharmsMessage: root.querySelector('[data-builder-bespoke-charms-message]'),
      charmCounterText: root.querySelector('[data-builder-charm-counter-text]'),
      reviewList: root.querySelector('[data-builder-review-list]'),
      backBtn: root.querySelector('[data-builder-back]'),
      reviewBtn: root.querySelector('[data-builder-review-btn]'),
      addToBagBtn: root.querySelector('[data-builder-add-to-bag]'),
      editBtn: root.querySelector('[data-builder-go-edit]'),
      editTray: root.querySelector('[data-builder-edit-tray]'),
      editBackdrop: root.querySelector('[data-builder-edit-backdrop]'),
      engraveTray: root.querySelector('[data-builder-engrave-tray]'),
      engraveBackdrop: root.querySelector('[data-builder-engrave-backdrop]'),
      engraveTitle: root.querySelector('[data-builder-engrave-title]'),
      engraveGallery: root.querySelector('[data-builder-engrave-gallery]'),
      engraveGalleryTrack: root.querySelector('[data-builder-engrave-gallery-track]'),
      engraveHint: root.querySelector('[data-builder-engrave-hint]'),
      engraveLabel: root.querySelector('[data-builder-engrave-label]'),
      engraveMax: root.querySelector('[data-builder-engrave-max]'),
      engraveInput: root.querySelector('[data-builder-engrave-input]'),
      engraveError: root.querySelector('[data-builder-engrave-error]'),
      engraveNotes: root.querySelector('[data-builder-engrave-notes]'),
      engraveNotesTitle: root.querySelector('[data-builder-engrave-notes-title]'),
      engraveNotesList: root.querySelector('[data-builder-engrave-notes-list]'),
      closeEngrave: root.querySelector('[data-builder-close-engrave]'),
      engraveSkip: root.querySelector('[data-builder-engrave-skip]'),
      engraveConfirm: root.querySelector('[data-builder-engrave-confirm]'),
      selectedCharms: root.querySelector('[data-builder-selected-charms]'),
      closeEdit: root.querySelector('[data-builder-close-edit]'),
      editHint: root.querySelector('[data-builder-edit-hint]'),
      saveEdit: root.querySelector('[data-builder-save-edit]'),
      startOrder: root.querySelector('[data-builder-start-order]'),
      priceTooltip: root.querySelector('[data-builder-price-tooltip]'),
      sidebarFooter: root.querySelector('[data-builder-sidebar-footer]'),
      runningTotal: root.querySelector('[data-builder-running-total]'),
      runningTotalValue: root.querySelector('[data-builder-running-total-value]'),
      thingsToKnow: root.querySelector('[data-builder-things-to-know]'),
      charmValidation: root.querySelector('[data-builder-charm-validation]'),
      previewCol: root.querySelector('.product-builder__preview-col'),
      canvas: root.querySelector('[data-builder-canvas]'),
      previewZoomOpenBtn: root.querySelector('[data-builder-preview-zoom-open]'),
      previewZoomOverlay: root.querySelector('[data-builder-preview-zoom]'),
      previewZoomViewport: root.querySelector('[data-builder-preview-zoom-viewport]'),
      previewZoomStage: root.querySelector('[data-builder-preview-zoom-stage]'),
      previewZoomCanvas: root.querySelector('[data-builder-preview-zoom-canvas]'),
      previewZoomCloseBtns: root.querySelectorAll('[data-builder-preview-zoom-close]'),
      previewActions: root.querySelector('[data-builder-preview-actions]'),
      previewLayoutSwitch: root.querySelector('[data-builder-preview-layout-switch]'),
      previewLayoutThumbA: root.querySelector('[data-builder-preview-layout-thumb-a]'),
      previewLayoutThumbB: root.querySelector('[data-builder-preview-layout-thumb-b]')
    };
  }

  ProductBuilder.prototype.getPreviewLayoutOrder = function () {
    var preview = this.config.preview || {};
    var layouts = preview.layouts;
    if (!layouts || typeof layouts !== 'object') return [];

    if (Array.isArray(preview.layout_order) && preview.layout_order.length) {
      var ordered = preview.layout_order.filter(function (key) {
        return layouts[key];
      });

      Object.keys(layouts).forEach(function (key) {
        if (ordered.indexOf(key) === -1) {
          ordered.push(key);
        }
      });

      return ordered;
    }

    return Object.keys(layouts);
  };

  ProductBuilder.prototype.usesVariantPreviewImages = function () {
    var preview = this.config.preview || {};
    return preview.use_variant_images === true;
  };

  ProductBuilder.prototype.getBasePreviewImages = function () {
    var productImages = (this.data.base && this.data.base.preview_images) || {};

    if (!this.usesVariantPreviewImages()) {
      return productImages;
    }

    var variant = this.getBaseVariant();
    if (!variant) return productImages;

    var variantImages = variant.preview_images || {};
    return {
      line: variantImages.line || variant.featured_image || productImages.line || '',
      circle: variantImages.circle || productImages.circle || ''
    };
  };

  ProductBuilder.prototype.getPreviewLayoutOptions = function () {
    var preview = this.config.preview || {};
    var layouts = preview.layouts;
    if (!layouts || typeof layouts !== 'object') return [];

    return this.getPreviewLayoutOrder().filter(function (key) {
      var layout = layouts[key];
      if (!layout || layout.enabled === false) return false;
      if (key === 'line') return true;

      var images = this.getBasePreviewImages();
      return Boolean(images[key]);
    }, this);
  };

  ProductBuilder.prototype.hasPreviewLayoutToggle = function () {
    var preview = this.config.preview || {};
    if (preview.layout_toggle === false) return false;
    return this.getPreviewLayoutOptions().length > 1;
  };

  ProductBuilder.prototype.getDefaultPreviewLayout = function () {
    var preview = this.config.preview || {};
    var options = this.getPreviewLayoutOptions();

    if (preview.default_layout && options.indexOf(preview.default_layout) !== -1) {
      return preview.default_layout;
    }

    return options[0] || 'line';
  };

  ProductBuilder.prototype.getActivePreviewLayout = function () {
    var options = this.getPreviewLayoutOptions();
    if (!options.length) return '';

    if (this.activePreviewLayout && options.indexOf(this.activePreviewLayout) !== -1) {
      return this.activePreviewLayout;
    }

    return this.getDefaultPreviewLayout();
  };

  ProductBuilder.prototype.getPreviewLayoutDefinition = function (layoutId) {
    var preview = this.config.preview || {};
    if (!layoutId || !preview.layouts || !preview.layouts[layoutId]) return null;
    return preview.layouts[layoutId];
  };

  ProductBuilder.prototype.getActivePreviewSettings = function () {
    var preview = this.config.preview || {};
    var layoutId = this.getActivePreviewLayout();
    var layout = this.getPreviewLayoutDefinition(layoutId);
    var settings = {};

    Object.keys(preview).forEach(function (key) {
      if (key === 'layouts' || key === 'default_layout' || key === 'layout_toggle') return;
      settings[key] = preview[key];
    });

    if (layout) {
      Object.keys(layout).forEach(function (key) {
        if (key === 'label' || key === 'enabled') return;
        if (layout[key] != null) settings[key] = layout[key];
      });
    }

    return settings;
  };

  ProductBuilder.prototype.getActivePlacement = function () {
    var placement = this.placement || {};
    var layoutId = this.getActivePreviewLayout();
    if (!layoutId || !placement.layouts || !placement.layouts[layoutId]) {
      return placement;
    }

    var layoutPlacement = placement.layouts[layoutId];
    var merged = Object.assign({}, placement);

    ['slots', 'slot_sets', 'custom_slots', 'spacing_percent', 'offset_x_percent', 'offset_y_percent', 'charm_size_percent'].forEach(function (key) {
      if (layoutPlacement[key] != null) {
        merged[key] = layoutPlacement[key];
      }
    });

    return merged;
  };

  ProductBuilder.prototype.getPreviewLayoutLabel = function (layoutId) {
    var layout = this.getPreviewLayoutDefinition(layoutId);
    if (layout && layout.label) return String(layout.label);

    if (layoutId === 'circle') return 'Circle';
    if (layoutId === 'line') return 'Line';
    return layoutId;
  };

  ProductBuilder.prototype.getAlternatePreviewLayout = function () {
    var options = this.getPreviewLayoutOptions();
    if (options.length < 2) return '';

    var activeLayout = this.getActivePreviewLayout();
    var activeIndex = options.indexOf(activeLayout);

    if (activeIndex === -1) {
      return options[0];
    }

    return options[(activeIndex + 1) % options.length];
  };

  ProductBuilder.prototype.getPreviewLayoutThumbnailUrl = function (layoutId) {
    var layout = this.getPreviewLayoutDefinition(layoutId);
    if (layout && layout.thumbnail) {
      return String(layout.thumbnail);
    }

    return this.getBasePreviewImageUrlForLayout(layoutId);
  };

  ProductBuilder.prototype.setPreviewLayout = function (layoutId) {
    if (!layoutId || this.getPreviewLayoutOptions().indexOf(layoutId) === -1) return;

    if (this.getActivePreviewLayout() === layoutId) return;

    var self = this;
    var targetUrl = this.getBasePreviewImageUrlForLayout(layoutId);
    var animate = this.shouldAnimateBuilderOpen();

    this.cancelPreviewLayoutSwitch();

    var applyLayoutSwitch = function () {
      self.activePreviewLayout = layoutId;
      self.closePreviewZoom();
      self.applyPreviewAppearance();

      if (self.els.baseImage && targetUrl) {
        self.els.baseImage.src = targetUrl;
      }

      self.renderPreview();

      var revealLayoutSwitch = function () {
        if (animate && self.root) {
          requestAnimationFrame(function () {
            self.root.classList.remove('product-builder--preview-layout-switching');
          });
        }
      };

      self.updatePreviewLayoutToggle({ crossfade: animate }, revealLayoutSwitch);
    };

    if (!animate) {
      if (!targetUrl) {
        applyLayoutSwitch();
        return;
      }

      var instantPreload = new Image();
      this.previewLayoutSwitchPreload = instantPreload;

      var finishInstant = function () {
        if (self.previewLayoutSwitchPreload !== instantPreload) return;
        self.previewLayoutSwitchPreload = null;
        applyLayoutSwitch();
      };

      instantPreload.onload = finishInstant;
      instantPreload.onerror = finishInstant;
      instantPreload.src = targetUrl;

      if (instantPreload.complete) {
        finishInstant();
      }

      return;
    }

    if (this.root) {
      this.root.classList.add('product-builder--preview-layout-switching');
    }

    var fadeComplete = false;
    var imageReady = !targetUrl;

    var tryApplyLayoutSwitch = function () {
      if (!fadeComplete || !imageReady) return;
      applyLayoutSwitch();
    };

    this.previewLayoutSwitchTimer = setTimeout(function () {
      self.previewLayoutSwitchTimer = null;
      fadeComplete = true;
      tryApplyLayoutSwitch();
    }, 350);

    if (targetUrl) {
      var preload = new Image();
      this.previewLayoutSwitchPreload = preload;

      var markImageReady = function () {
        if (self.previewLayoutSwitchPreload !== preload) return;
        self.previewLayoutSwitchPreload = null;
        imageReady = true;
        tryApplyLayoutSwitch();
      };

      preload.onload = markImageReady;
      preload.onerror = markImageReady;
      preload.src = targetUrl;

      if (preload.complete) {
        markImageReady();
      }
    }
  };

  ProductBuilder.prototype.cancelPreviewLayoutSwitch = function () {
    this.cancelBaseImageFade();

    if (this.previewLayoutSwitchTimer) {
      clearTimeout(this.previewLayoutSwitchTimer);
      this.previewLayoutSwitchTimer = null;
    }

    if (this.previewLayoutSwitchPreload) {
      this.previewLayoutSwitchPreload.onload = null;
      this.previewLayoutSwitchPreload.onerror = null;
      this.previewLayoutSwitchPreload = null;
    }

    if (this.root) {
      this.root.classList.remove('product-builder--preview-layout-switching');
    }

    this.updatePreviewLayoutToggle();
  };

  ProductBuilder.prototype.getActivePreviewLayoutThumb = function () {
    return this.previewLayoutThumbActive === 'b'
      ? this.els.previewLayoutThumbB
      : this.els.previewLayoutThumbA;
  };

  ProductBuilder.prototype.getInactivePreviewLayoutThumb = function () {
    return this.previewLayoutThumbActive === 'b'
      ? this.els.previewLayoutThumbA
      : this.els.previewLayoutThumbB;
  };

  ProductBuilder.prototype.setPreviewLayoutThumbImage = function (thumb, url, alt) {
    if (!thumb) return;

    if (url) {
      thumb.src = url;
      thumb.alt = alt;
      thumb.hidden = false;
      return;
    }

    thumb.removeAttribute('src');
    thumb.alt = '';
    thumb.hidden = true;
    thumb.classList.remove('is-active');
  };

  ProductBuilder.prototype.updatePreviewLayoutToggle = function (options, done) {
    options = options || {};
    var layoutSwitch = this.els.previewLayoutSwitch;
    var showToggle = this.hasPreviewLayoutToggle()
      && (this.step === 'choose' || this.step === 'edit' || this.step === 'review');
    var finish = typeof done === 'function' ? done : function () {};

    if (layoutSwitch) {
      layoutSwitch.hidden = !showToggle;
    }

    if (!showToggle || !layoutSwitch) {
      this.updatePreviewActionsVisibility();
      finish();
      return;
    }

    var alternateLayout = this.getAlternatePreviewLayout();
    var thumbUrl = alternateLayout ? this.getPreviewLayoutThumbnailUrl(alternateLayout) : '';
    var alternateLabel = alternateLayout ? this.getPreviewLayoutLabel(alternateLayout) : 'layout';
    var thumbAlt = thumbUrl ? 'Switch to ' + alternateLabel + ' preview' : '';
    var activeThumb = this.getActivePreviewLayoutThumb();
    var inactiveThumb = this.getInactivePreviewLayoutThumb();
    var self = this;

    layoutSwitch.setAttribute('aria-label', 'Switch to ' + alternateLabel + ' preview');
    layoutSwitch.dataset.builderPreviewLayout = alternateLayout;

    if (!thumbUrl) {
      this.setPreviewLayoutThumbImage(this.els.previewLayoutThumbA, '', '');
      this.setPreviewLayoutThumbImage(this.els.previewLayoutThumbB, '', '');
      this.previewLayoutThumbActive = 'a';
      this.updatePreviewActionsVisibility();
      finish();
      return;
    }

    if (activeThumb && activeThumb.getAttribute('src') === thumbUrl) {
      activeThumb.alt = thumbAlt;
      this.updatePreviewActionsVisibility();
      finish();
      return;
    }

    var applyThumb = function (targetThumb, previousThumb) {
      if (!targetThumb) return;

      self.setPreviewLayoutThumbImage(targetThumb, thumbUrl, thumbAlt);

      if (previousThumb && previousThumb !== targetThumb) {
        previousThumb.classList.remove('is-active');
      }

      targetThumb.classList.add('is-active');
      self.previewLayoutThumbActive = targetThumb === self.els.previewLayoutThumbB ? 'b' : 'a';

      if (inactiveThumb && inactiveThumb !== targetThumb) {
        inactiveThumb.classList.remove('is-active');
      }
    };

    var complete = function () {
      self.updatePreviewActionsVisibility();
      finish();
    };

    var shouldCrossfade = options.crossfade !== false
      && this.shouldAnimateBuilderOpen()
      && activeThumb
      && activeThumb.getAttribute('src')
      && inactiveThumb;

    if (shouldCrossfade) {
      var preload = new Image();
      var finished = false;

      var finishCrossfade = function () {
        if (finished) return;
        finished = true;
        applyThumb(inactiveThumb, activeThumb);
        complete();
      };

      preload.onload = finishCrossfade;
      preload.onerror = finishCrossfade;
      preload.src = thumbUrl;

      if (preload.complete) {
        finishCrossfade();
      }

      return;
    }

    applyThumb(activeThumb || this.els.previewLayoutThumbA, null);

    if (inactiveThumb && inactiveThumb !== activeThumb) {
      this.setPreviewLayoutThumbImage(inactiveThumb, '', '');
      inactiveThumb.classList.remove('is-active');
    }

    complete();
  };

  ProductBuilder.prototype.renderPreviewLayoutToggle = function () {
    this.updatePreviewLayoutToggle();
  };

  ProductBuilder.prototype.updatePreviewActionsVisibility = function () {
    var actions = this.els.previewActions;
    var showLayout = this.hasPreviewLayoutToggle()
      && (this.step === 'choose' || this.step === 'edit' || this.step === 'review');

    if (this.els.previewZoomOpenBtn) {
      this.els.previewZoomOpenBtn.hidden = !this.shouldShowPreviewZoomButton();
    }

    if (this.els.previewLayoutSwitch) {
      this.els.previewLayoutSwitch.hidden = !showLayout;
    }

    if (actions) {
      actions.hidden = !showLayout;
    }
  };

  ProductBuilder.prototype.getInitialVariantId = function () {
    var variants = this.data.base.variants || [];
    var available = variants.find(function (v) {
      return this.isVariantPurchasable(v);
    }, this);
    return (available || variants[0] || {}).id || null;
  };

  ProductBuilder.prototype.getBaseVariant = function () {
    var id = Number(this.baseVariantId);
    return (this.data.base.variants || []).find(function (v) {
      return Number(v.id) === id;
    }) || null;
  };

  ProductBuilder.prototype.isVariantPurchasable = function (variant) {
    if (!variant) return false;
    if (variant.available) return true;
    if (variant.inventory_policy === 'continue') return true;
    return false;
  };

  ProductBuilder.prototype.isBaseVariantAvailable = function () {
    var variant = this.getBaseVariant();
    if (!variant) return false;

    var live = (window.variants || []).find(function (v) {
      return Number(v.id) === Number(variant.id);
    });

    return this.isVariantPurchasable(live || variant);
  };

  ProductBuilder.prototype.getVariantSnapshotSources = function () {
    var sources = [];

    if (window.variants && window.variants.length) {
      sources.push(window.variants);
    }

    if (this.data.base && this.data.base.variants) {
      sources.push(this.data.base.variants);
    }

    var productJson = document.querySelector('[data-product-json]');
    if (productJson && productJson.textContent) {
      try {
        var parsed = JSON.parse(productJson.textContent);
        if (parsed.variants && parsed.variants.length) {
          sources.push(parsed.variants);
        }
      } catch (e) {
        /* ignore */
      }
    }

    return sources;
  };

  ProductBuilder.prototype.findVariantSnapshot = function (variantId) {
    var id = Number(variantId);
    if (!id) return null;

    var sources = this.getVariantSnapshotSources();
    var i;
    var match;

    for (i = 0; i < sources.length; i++) {
      match = sources[i].find(function (variant) {
        return Number(variant.id) === id;
      });
      if (match) return match;
    }

    for (i = 0; i < this.charmGroups.length; i++) {
      var group = this.charmGroups[i];
      var variants = group.variants || [];
      var j;

      for (j = 0; j < variants.length; j++) {
        if (Number(variants[j].id) === id) return variants[j];
      }

      if (group.products) {
        for (j = 0; j < group.products.length; j++) {
          var productVariants = group.products[j].variants || [];
          var k;
          for (k = 0; k < productVariants.length; k++) {
            if (Number(productVariants[k].id) === id) return productVariants[k];
          }
        }
      }
    }

    return null;
  };

  ProductBuilder.prototype.syncVariantInventory = function (variant, live, options) {
    options = options || {};
    if (!variant) return variant;

    var snapshot = this.findVariantSnapshot((live && live.id) || variant.id);
    if (snapshot) {
      if (snapshot.inventory_policy) variant.inventory_policy = snapshot.inventory_policy;
      if (snapshot.inventory_management) variant.inventory_management = snapshot.inventory_management;
      if (snapshot.inventory_quantity != null) variant.inventory_quantity = snapshot.inventory_quantity;
    }

    if (live) {
      if (live.inventory_policy) variant.inventory_policy = live.inventory_policy;
      if (live.inventory_management) variant.inventory_management = live.inventory_management;
      if (live.inventory_quantity != null) variant.inventory_quantity = live.inventory_quantity;
      if (live.price != null) variant.price = live.price;
      if (live.available != null) variant.available = live.available;
    }

    variant.available = this.isVariantPurchasable(variant);
    return variant;
  };

  ProductBuilder.prototype.applyBaseVariantFromLive = function (liveVariant) {
    if (!liveVariant) return;

    this.baseVariantId = Number(liveVariant.id);

    var base = this.getBaseVariant();
    if (base) {
      this.syncVariantInventory(base, liveVariant);
    }

    this.updateBasePreview();
    if (this.usesVariantPreviewImages()) {
      this.updatePreviewLayoutToggle();
      if (this.step !== 'product') {
        this.renderPreview();
      }
    }
    this.updateRunningTotal();
  };

  ProductBuilder.prototype.syncVariantFromOptionSelectors = function () {
    var variants = window.variants || this.data.base.variants || [];
    var productSection = document.querySelector('[data-section-type="product"]');
    if (!productSection || !variants.length) return;

    var selectedOptions = [];
    var positionsSeen = {};

    productSection.querySelectorAll('[data-single-option-selector]').forEach(function (el) {
      var index = el.dataset.index;
      if (!index || index.indexOf('option') !== 0) return;

      var pos = Number(index.replace('option', '')) - 1;
      if (positionsSeen[pos]) return;
      positionsSeen[pos] = true;
      selectedOptions[pos] = el.value;
    });

    var match = variants.find(function (variant) {
      return selectedOptions.every(function (value, index) {
        if (!value) return true;
        return variant['option' + (index + 1)] === value;
      });
    });

    if (match) {
      this.applyBaseVariantFromLive(match);
    }
  };

  ProductBuilder.prototype.syncBaseVariantAvailability = function (variant) {
    if (!variant) return;
    this.applyBaseVariantFromLive(variant);
  };

  ProductBuilder.prototype.updateLaunchButton = function () {
    var optionalBase = document.querySelector('[data-builder-optional-base]');
    var addToCartBtn = document.querySelector('[data-add-to-cart]');
    var soldOutBtn = document.querySelector('.klaviyo-bis-trigger.sold-out-btn');
    var available = this.isBaseVariantAvailable();

    if (this.els.launch) {
      if (available) {
        this.els.launch.style.display = '';
        this.els.launch.disabled = false;
        this.els.launch.removeAttribute('disabled');
      } else {
        this.els.launch.style.display = 'none';
        this.els.launch.disabled = true;
      }
    }

    if (optionalBase && addToCartBtn) {
      if (available) {
        addToCartBtn.style.display = '';
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('disabled');
        if (soldOutBtn) soldOutBtn.style.display = 'none';
      } else {
        addToCartBtn.style.display = 'none';
        addToCartBtn.disabled = true;
        if (soldOutBtn) soldOutBtn.style.display = '';
      }
      return;
    }

    if (available) {
      if (soldOutBtn) soldOutBtn.style.display = 'none';
      return;
    }

    if (soldOutBtn) soldOutBtn.style.display = '';
  };

  ProductBuilder.prototype.getCharmVariant = function (variantId) {
    return this.charmTiles.find(function (tile) {
      return Number(tile.id) === Number(variantId);
    }) || null;
  };

  ProductBuilder.prototype.isVariantStockTracked = function (tileData) {
    if (!tileData || tileData.inventory_policy === 'continue') return false;
    if (tileData.inventory_management === 'shopify') return true;

    // Liquid bootstrap may include quantity even when management field is absent
    var quantity = parseInventoryQuantity(tileData.inventory_quantity);
    return quantity !== null && tileData.inventory_policy === 'deny';
  };

  ProductBuilder.prototype.getVariantStockCap = function (tileData) {
    if (!tileData || !this.isVariantPurchasable(tileData)) return 0;
    if (!this.isVariantStockTracked(tileData)) return null;

    var quantity = parseInventoryQuantity(tileData.inventory_quantity);
    if (quantity === null) return null;

    var inCart = 0;
    if (this.cartVariantCounts) {
      inCart = this.cartVariantCounts[String(tileData.id)] || 0;
    }

    return Math.max(0, quantity - inCart);
  };

  ProductBuilder.prototype.canAddCharmVariant = function (tileData) {
    if (!tileData || !this.isVariantPurchasable(tileData) || !tileData.preview_image) return false;
    if (this.getSelectedCharmCount() >= this.getPoolMax()) return false;
    if (this.hasSlotGroups() && this.getNextAddIndex() === -1) return false;

    var selectedCount = countCharmsForVariant(this.selectedCharms, tileData.id);
    var stockCap = this.getVariantStockCap(tileData);

    if (stockCap !== null && selectedCount >= stockCap) return false;

    return true;
  };

  ProductBuilder.prototype.loadCartVariantCounts = function () {
    var self = this;

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var counts = {};
        (cart.items || []).forEach(function (item) {
          var id = String(item.variant_id);
          counts[id] = (counts[id] || 0) + item.quantity;
        });
        self.cartVariantCounts = counts;
      })
      .catch(function () {
        self.cartVariantCounts = {};
      });
  };

  ProductBuilder.prototype.refreshCharmCatalog = function () {
    var self = this;
    return this.loadCartVariantCounts().then(function () {
      return self.enrichCharmStock();
    });
  };

  ProductBuilder.prototype.getPoolMin = function () {
    var pool = this.data.pool || {};
    var sources = [pool.min_charms, this.config.min_charms, this.charmGroup && this.charmGroup.min];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 1;
  };

  ProductBuilder.prototype.getPoolMax = function () {
    var pool = this.data.pool || {};
    var sources = [pool.max_charms, this.config.max_charms, this.charmGroup && this.charmGroup.max];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 5;
  };

  ProductBuilder.prototype.getGridColumns = function () {
    var pool = this.data.pool || {};
    var sources = [pool.grid_columns, this.config.grid_columns, this.charmGroup && this.charmGroup.grid_columns];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 6;
  };

  ProductBuilder.prototype.getCharmTileLabel = function (tileData) {
    if (!tileData) return '';
    var label = '';
    if (tileData.type === 'letter') {
      label = String(tileData.letter || tileData.label || tileData.title || '').trim();
    } else {
      label = String(tileData.label || tileData.letter || tileData.design_token || tileData.title || '').trim();
    }
    return label.replace(/\s+Pendant\s*$/i, '');
  };

  ProductBuilder.prototype.isExcludedCharmTile = function (tileData) {
    if (!tileData) return false;

    var labels = [
      tileData.label,
      tileData.letter,
      tileData.title,
      tileData.design_token,
      tileData.product_title,
      this.getCharmTileLabel(tileData)
    ];

    for (var i = 0; i < labels.length; i++) {
      if (isExcludedCharmLabel(labels[i])) {
        return true;
      }
    }

    return false;
  };

  ProductBuilder.prototype.getPanelTitle = function () {
    if (this.config.panel_title) return this.config.panel_title;
    if (this.charmGroup && this.charmGroup.label) return this.charmGroup.label;
    return 'Choose Your Charms';
  };

  ProductBuilder.prototype.hasCharmCatalog = function () {
    return this.charmTiles.length > 0 || this.charmGroups.length > 0;
  };

  ProductBuilder.prototype.charmGroupsHaveVariants = function () {
    if (!this.charmGroups.length) return false;

    for (var i = 0; i < this.charmGroups.length; i++) {
      var group = this.charmGroups[i];
      var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

      if (groupType === 'products' && group.products && group.products.length) {
        for (var j = 0; j < group.products.length; j++) {
          if ((group.products[j].variants || []).length) return true;
        }
      } else if ((group.variants || []).length) {
        return true;
      }
    }

    return false;
  };

  ProductBuilder.prototype.normalizeCharmGroups = function () {
    if (this.charmGroupsHaveVariants()) return;

    var configCharms = this.config.charms;
    if (!configCharms || !configCharms.length) {
      console.warn('[ProductBuilder] No charms defined in config');
      return;
    }

    this.charmGroups = configCharms.map(function (group, index) {
      var hasProducts = group.products && group.products.length;
      var type = group.type || (hasProducts ? 'products' : 'letter');
      var normalized = {
        id: group.id || group.product_handle || ('group-' + (index + 1)),
        type: type,
        label: group.label || 'Choose your charms',
        product_handle: group.product_handle || null,
        product_title: null,
        size_percent: group.size_percent != null ? group.size_percent : null,
        variants: []
      };

      if (type === 'products' && hasProducts) {
        normalized.products = group.products.map(function (entry) {
          if (typeof entry === 'string') {
            return {
              product_handle: entry,
              label: '',
              design_token: '',
              product_title: null,
              variants: []
            };
          }

          return {
            product_handle: entry.product_handle,
            label: entry.label || '',
            design_token: entry.design_token || '',
            preview_image: entry.preview_image || '',
            preview_image_blank: entry.preview_image_blank || '',
            product_title: entry.product_title || null,
            size_percent: entry.size_percent != null ? entry.size_percent : null,
            engraving: entry.engraving || null,
            gallery_images: entry.gallery_images || [],
            variants: entry.variants || []
          };
        });
      }

      return normalized;
    });

    this.charmGroup = this.charmGroups[0] || null;
  };

  ProductBuilder.prototype.getCharmPreviewImageWidth = function () {
    var preview = this.config.preview || {};
    if (preview.charm_image_width == null || preview.charm_image_width === '') {
      return null;
    }

    var width = parseInt(String(preview.charm_image_width), 10);
    if (isNaN(width) || width <= 0) return null;
    return width;
  };

  ProductBuilder.prototype.resolveCharmPreviewImageUrl = function (url) {
    if (!url) return '';

    var width = this.getCharmPreviewImageWidth();
    if (width == null) return url;

    if (/([?&])width=\d+/.test(url)) {
      return url.replace(/([?&])width=\d+/, '$1width=' + width);
    }

    return url + (url.indexOf('?') !== -1 ? '&' : '?') + 'width=' + width;
  };

  ProductBuilder.prototype.getCharmShadowConfig = function () {
    var preview = this.config.preview || {};
    return preview.charm_shadow != null ? preview.charm_shadow : null;
  };

  ProductBuilder.prototype.formatCharmShadowColor = function (color, opacity) {
    if (!color) return 'rgba(178, 158, 143, 1)';

    var colorStr = String(color).trim();
    if (/^rgba?\(/i.test(colorStr) || /^hsla?\(/i.test(colorStr)) {
      return colorStr;
    }

    if (colorStr.charAt(0) === '#') {
      return colorStr;
    }

    var alpha = opacity == null ? 1 : Number(opacity);
    if (isNaN(alpha)) alpha = 1;
    return 'rgba(' + colorStr + ', ' + alpha + ')';
  };

  ProductBuilder.prototype.getCharmShadowFilter = function (scale) {
    var shadow = this.getCharmShadowConfig();
    var multiplier = scale == null ? 1 : Number(scale);
    if (!multiplier || isNaN(multiplier) || multiplier < 0) multiplier = 1;

    if (shadow === false || shadow === 'none') {
      return 'none';
    }

    if (typeof shadow === 'string') {
      var trimmed = shadow.trim();
      return trimmed ? trimmed : null;
    }

    if (!shadow || typeof shadow !== 'object') {
      return null;
    }

    if (shadow.enabled === false) {
      return 'none';
    }

    var x = shadow.x != null ? shadow.x : shadow.offset_x;
    var y = shadow.y != null ? shadow.y : shadow.offset_y;
    var blur = shadow.blur != null ? shadow.blur : shadow.blur_radius;
    var color = this.formatCharmShadowColor(shadow.color, shadow.opacity);

    x = x == null || x === '' ? 3 : Number(x);
    y = y == null || y === '' ? 2 : Number(y);
    blur = blur == null || blur === '' ? 1 : Number(blur);

    if (isNaN(x)) x = 3;
    if (isNaN(y)) y = 2;
    if (isNaN(blur)) blur = 1;

    x = x * multiplier;
    y = y * multiplier;
    blur = blur * multiplier;

    return x + 'px ' + y + 'px ' + blur + 'px ' + color;
  };

  ProductBuilder.prototype.getPreviewZoomShadowScale = function () {
    // Stage transform already scales drop-shadow visually. Only compensate when
    // the zoom canvas itself is resized larger (Safari / touch high-res path),
    // where local px shadows would otherwise stay tiny relative to the charms.
    return this.getPreviewZoomCanvasMultiplier() || 1;
  };

  ProductBuilder.prototype.applyPreviewZoomCharmShadow = function () {
    var canvas = this.els.previewZoomCanvas;
    if (!canvas) return;

    var layer = canvas.querySelector('.product-builder__charms-layer');
    if (!layer) return;

    var shadow = this.getCharmShadowFilter(this.getPreviewZoomShadowScale());

    if (shadow === 'none') {
      layer.style.filter = 'none';
    } else if (shadow) {
      layer.style.filter = 'drop-shadow(' + shadow + ')';
    } else {
      layer.style.removeProperty('filter');
    }
  };

  ProductBuilder.PREVIEW_MOBILE_QUERY = '(max-width: 900px)';

  ProductBuilder.prototype.isPreviewMobileViewport = function () {
    return window.matchMedia(ProductBuilder.PREVIEW_MOBILE_QUERY).matches;
  };

  ProductBuilder.prototype.getPreviewCanvasAspectRatio = function () {
    var preview = this.getActivePreviewSettings();
    var value = preview.canvas_aspect_ratio;

    if (value != null && String(value).trim() !== '') {
      return String(value).trim();
    }

    if (this.hasSlotGroups()) return '3 / 4';

    return null;
  };

  ProductBuilder.prototype.getPreviewColBackground = function () {
    var preview = this.getActivePreviewSettings();
    var value = preview.background_color || preview.preview_col_background;
    if (!value) return '';

    var hex = String(value).trim();
    if (/^#[0-9a-fA-F]{3}$/.test(hex) || /^#[0-9a-fA-F]{6}$/.test(hex)) {
      return hex;
    }
    if (/^[0-9a-fA-F]{3}$/.test(hex) || /^[0-9a-fA-F]{6}$/.test(hex)) {
      return '#' + hex;
    }

    return '';
  };

  ProductBuilder.prototype.applyPreviewAppearance = function () {
    var layer = this.els.charmsLayer;
    var baseImage = this.els.baseImage;
    var canvas = this.root.querySelector('[data-builder-canvas]');
    var position = this.getPreviewImagePosition();
    var topAligned = this.isPreviewTopAligned();
    var portrait = topAligned && !!this.getPreviewCanvasAspectRatio();
    var transform = this.getPreviewImageTransform();

    this.root.classList.toggle('product-builder--preview-top', topAligned);
    this.root.classList.toggle('product-builder--preview-portrait', portrait);
    this.root.classList.toggle('product-builder--preview-edge-to-edge', this.isPreviewEdgeToEdge());

    if (this.els.previewCol) {
      var previewBackground = this.getPreviewColBackground();
      if (previewBackground) {
        this.els.previewCol.style.backgroundColor = previewBackground;
      } else {
        this.els.previewCol.style.removeProperty('background-color');
      }
    }

    if (layer) {
      var shadow = this.getCharmShadowFilter();

      if (shadow === 'none') {
        layer.style.filter = 'none';
      } else if (shadow) {
        layer.style.filter = 'drop-shadow(' + shadow + ')';
      } else {
        layer.style.removeProperty('filter');
      }
    }

    if (baseImage) {
      baseImage.style.objectPosition = position;
    }

    if (canvas) {
      canvas.classList.toggle('product-builder__canvas--align-top', topAligned);

      if (portrait) {
        canvas.style.setProperty('--preview-aspect-ratio', this.getPreviewCanvasAspectRatio());
      } else {
        canvas.style.removeProperty('--preview-aspect-ratio');
      }

      if (transform.offsetY || transform.scale !== 1) {
        canvas.classList.add('product-builder__canvas--preview-transform');
        canvas.style.setProperty('--preview-image-scale', String(transform.scale));
        canvas.style.setProperty('--preview-image-offset-y', transform.offsetY + '%');
      } else {
        canvas.classList.remove('product-builder__canvas--preview-transform');
        canvas.style.removeProperty('--preview-image-scale');
        canvas.style.removeProperty('--preview-image-offset-y');
      }
    }

    if (layer) {
      layer.style.removeProperty('transform');
      layer.style.removeProperty('transform-origin');
    }

    if (baseImage) {
      baseImage.style.removeProperty('transform');
      baseImage.style.removeProperty('transform-origin');
    }
  };

  ProductBuilder.prototype.ensureBuilderPortal = function () {
    if (this.root && this.root.parentNode !== document.body) {
      document.body.appendChild(this.root);
    }
  };

  ProductBuilder.prototype.hasPreviewZoom = function () {
    var preview = this.config.preview || {};
    return preview.zoom_enabled === true;
  };

  ProductBuilder.prototype.getPreviewZoomScale = function () {
    var preview = this.config.preview || {};
    var scale = parseFloat(preview.zoom_scale);
    if (isNaN(scale) || scale <= 1) return 2.5;
    return scale;
  };

  ProductBuilder.prototype.getPreviewZoomFocusPoint = function () {
    var preview = this.getActivePreviewSettings();

    if (preview.zoom_focus === 'canvas') {
      return { x: 50, y: 50 };
    }

    if (preview.zoom_focus_x_percent != null && preview.zoom_focus_y_percent != null) {
      return {
        x: Number(preview.zoom_focus_x_percent),
        y: Number(preview.zoom_focus_y_percent)
      };
    }

    var points = this.collectPreviewZoomFocusPoints();
    if (!points.length) {
      return { x: 50, y: 50 };
    }

    var sumX = 0;
    var sumY = 0;

    points.forEach(function (point) {
      sumX += point.x;
      sumY += point.y;
    });

    return {
      x: sumX / points.length,
      y: sumY / points.length
    };
  };

  ProductBuilder.prototype.collectPreviewZoomFocusPoints = function () {
    var points = [];
    var mode = this.getPlacementMode();

    if (mode === 'along_line') {
      var placement = this.getActivePlacement();
      points.push({
        x: placement.offset_x_percent != null ? Number(placement.offset_x_percent) : 50,
        y: placement.offset_y_percent != null ? Number(placement.offset_y_percent) : 50
      });
      return points;
    }

    if (this.hasSlotGroups()) {
      this.forEachSelectedCharm(function (charm, slotIndex) {
        var slot = this.getPreviewSlotForIndex(slotIndex);
        if (slot) {
          points.push({ x: slot.x, y: slot.y });
        }
      }, this);

      if (points.length) {
        return points;
      }

      var groups = this.getSlotGroups();
      if (groups.length) {
        var fallbackPositions = this.getGroupSlotPositions(groups[0], 1);
        if (fallbackPositions.length) {
          points.push({
            x: fallbackPositions[0].x,
            y: fallbackPositions[0].y
          });
        }
      }

      return points;
    }

    var count = this.getSelectedCharmCount();
    var slotCount = count > 0 ? count : 1;
    var slots = this.getCharmSlots(slotCount);

    slots.forEach(function (slot) {
      points.push({ x: slot.x, y: slot.y });
    });

    return points;
  };

  ProductBuilder.prototype.applyPreviewZoomFocusPan = function () {
    var transform = this.previewZoomTransform;
    var canvas = this.els.previewZoomCanvas;
    if (!transform || !canvas) return;

    var focus = this.getPreviewZoomFocusPoint();
    var canvasWidth = canvas.offsetWidth || 0;
    var canvasHeight = canvas.offsetHeight || 0;

    if (!canvasWidth || !canvasHeight) {
      transform.x = 0;
      transform.y = 0;
      return;
    }

    if (Math.abs(focus.x - 50) < 0.01 && Math.abs(focus.y - 50) < 0.01) {
      transform.x = 0;
      transform.y = 0;
      return;
    }

    var offsetX = ((focus.x - 50) / 100) * canvasWidth;
    var offsetY = ((focus.y - 50) / 100) * canvasHeight;

    transform.x = -offsetX * transform.scale;
    transform.y = -offsetY * transform.scale;
  };

  ProductBuilder.prototype.shouldShowPreviewZoomButton = function () {
    return this.hasPreviewZoom() && (this.step === 'choose' || this.step === 'edit');
  };

  ProductBuilder.prototype.updatePreviewZoomButtonVisibility = function () {
    this.updatePreviewActionsVisibility();
  };

  ProductBuilder.prototype.copyCanvasStylesForZoom = function (sourceCanvas, targetCanvas) {
    if (!sourceCanvas || !targetCanvas) return;

    targetCanvas.className = 'product-builder__preview-zoom-canvas';
    Array.prototype.slice.call(sourceCanvas.classList).forEach(function (className) {
      if (className !== 'product-builder__canvas') {
        targetCanvas.classList.add(className);
      }
    });

    [
      '--preview-size',
      '--preview-aspect-ratio',
      '--preview-width',
      '--preview-image-scale',
      '--preview-image-offset-y'
    ].forEach(function (name) {
      targetCanvas.style.removeProperty(name);
    });
  };

  ProductBuilder.prototype.measurePreviewZoomFitScale = function () {
    var viewport = this.els.previewZoomViewport;
    var canvas = this.els.previewZoomCanvas;
    if (!viewport || !canvas) return 1;

    return this.measurePreviewZoomFitScaleForSize(
      canvas.offsetWidth || 1,
      canvas.offsetHeight || 1
    );
  };

  ProductBuilder.prototype.measurePreviewZoomFitScaleForSize = function (width, height) {
    var viewport = this.els.previewZoomViewport;
    if (!viewport) return 1;

    var padding = 48;
    var vw = Math.max(viewport.clientWidth - padding, 1);
    var vh = Math.max(viewport.clientHeight - padding, 1);
    var cw = width || 1;
    var ch = height || 1;

    return Math.min(vw / cw, vh / ch);
  };

  ProductBuilder.prototype.getPreviewZoomBaseFitScale = function () {
    var sourceSize = this.getPreviewZoomSourceSize();
    if (!sourceSize.width || !sourceSize.height) {
      return this.measurePreviewZoomFitScale();
    }

    return this.measurePreviewZoomFitScaleForSize(sourceSize.width, sourceSize.height);
  };

  ProductBuilder.prototype.usesPreviewZoomCanvasResize = function () {
    if (typeof window === 'undefined') return false;

    var ua = window.navigator.userAgent || '';
    var isSafari = /Safari/i.test(ua) && !/Chrome|CriOS|Chromium|Edg|OPR|Firefox|FxiOS|Android/i.test(ua);
    var isIOS = /iPad|iPhone|iPod/i.test(ua)
      || (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);

    return isSafari || isIOS || window.matchMedia('(pointer: coarse)').matches;
  };

  ProductBuilder.prototype.ensurePreviewZoomCanvasResolution = function () {
    var targetCanvas = this.els.previewZoomCanvas;
    if (!targetCanvas) return;

    if (!this.usesPreviewZoomCanvasResize()) {
      targetCanvas.classList.remove('product-builder__preview-zoom-canvas--high-res');
      return;
    }

    this.setPreviewZoomCanvasMultiplier(this.getPreviewZoomScale());
    targetCanvas.classList.add('product-builder__preview-zoom-canvas--high-res');
  };

  ProductBuilder.prototype.clampPreviewZoomScale = function (scale) {
    var transform = this.previewZoomTransform;
    if (!transform) return scale;
    return Math.min(transform.zoomScale, Math.max(transform.fitScale, scale));
  };

  ProductBuilder.prototype.getPreviewZoomSourceSize = function () {
    var sourceCanvas = this.els.canvas;
    if (sourceCanvas && sourceCanvas.offsetWidth > 0 && sourceCanvas.offsetHeight > 0) {
      return {
        width: sourceCanvas.offsetWidth,
        height: sourceCanvas.offsetHeight
      };
    }

    if (this.previewZoomBaseSize) {
      return this.previewZoomBaseSize;
    }

    return { width: 0, height: 0 };
  };

  ProductBuilder.prototype.getPreviewZoomCanvasMultiplier = function () {
    var canvas = this.els.previewZoomCanvas;
    if (!canvas) return 1;
    return parseFloat(canvas.dataset.zoomMultiplier || '1') || 1;
  };

  ProductBuilder.prototype.setPreviewZoomCanvasMultiplier = function (multiplier) {
    var targetCanvas = this.els.previewZoomCanvas;
    var sourceSize = this.getPreviewZoomSourceSize();
    if (!targetCanvas || !sourceSize.width || !sourceSize.height) return;

    multiplier = multiplier || 1;
    targetCanvas.dataset.zoomMultiplier = String(multiplier);
    targetCanvas.style.width = (sourceSize.width * multiplier) + 'px';
    targetCanvas.style.height = (sourceSize.height * multiplier) + 'px';
  };

  ProductBuilder.prototype.refreshPreviewZoomTransform = function (animate) {
    var transform = this.previewZoomTransform;
    if (!transform) return;

    this.ensurePreviewZoomCanvasResolution();

    var previousFitScale = transform.fitScale || 1;
    var magnification = previousFitScale ? transform.scale / previousFitScale : 1;
    var fitScale = this.measurePreviewZoomFitScale();
    var maxScale = fitScale * this.getPreviewZoomScale();

    transform.fitScale = fitScale;
    transform.zoomScale = maxScale;
    transform.scale = this.clampPreviewZoomScale(fitScale * magnification);
    this.clampPreviewZoomPan();
    this.applyPreviewZoomTransform(animate);
  };

  ProductBuilder.prototype.resetPreviewZoomTransform = function (animate) {
    animate = animate && this.shouldAnimateBuilderOpen();
    this.ensurePreviewZoomCanvasResolution();

    var fitScale = this.measurePreviewZoomFitScale();
    var zoomMultiplier = this.getPreviewZoomScale();
    var maxScale = fitScale * zoomMultiplier;

    this.previewZoomTransform = {
      scale: fitScale,
      x: 0,
      y: 0,
      fitScale: fitScale,
      zoomScale: maxScale
    };
    this.applyPreviewZoomTransform(false);

    if (!animate) {
      this.previewZoomTransform.scale = maxScale;
      this.applyPreviewZoomFocusPan();
      this.clampPreviewZoomPan();
      this.applyPreviewZoomTransform(false);
      return;
    }

    var self = this;
    requestAnimationFrame(function () {
      if (!self.previewZoomOpen) return;

      self.previewZoomTransform.scale = maxScale;
      self.applyPreviewZoomFocusPan();
      self.clampPreviewZoomPan();
      self.applyPreviewZoomTransform(true);
    });
  };

  ProductBuilder.prototype.applyPreviewZoomTransform = function (animate) {
    var stage = this.els.previewZoomStage;
    var transform = this.previewZoomTransform;
    if (!stage || !transform) return;

    var x = Math.round(transform.x);
    var y = Math.round(transform.y);

    stage.style.transition = animate
      ? 'transform 0.32s cubic-bezier(0.22, 1, 0.36, 1)'
      : 'none';
    stage.style.transform =
      'translate3d(calc(-50% + ' + x + 'px), calc(-50% + ' + y + 'px), 0) scale(' + transform.scale + ')';

    this.applyPreviewZoomCharmShadow();
  };

  ProductBuilder.prototype.clampPreviewZoomPan = function () {
    var viewport = this.els.previewZoomViewport;
    var canvas = this.els.previewZoomCanvas;
    var transform = this.previewZoomTransform;
    if (!viewport || !canvas || !transform) return;

    var vw = viewport.clientWidth;
    var vh = viewport.clientHeight;
    var cw = canvas.offsetWidth * transform.scale;
    var ch = canvas.offsetHeight * transform.scale;
    var maxX = Math.max(0, (cw - vw) / 2);
    var maxY = Math.max(0, (ch - vh) / 2);

    transform.x = Math.min(maxX, Math.max(-maxX, transform.x));
    transform.y = Math.min(maxY, Math.max(-maxY, transform.y));
  };

  ProductBuilder.prototype.isPreviewZoomExpanded = function () {
    var transform = this.previewZoomTransform;
    if (!transform) return false;
    return transform.scale > transform.fitScale * 1.05;
  };

  ProductBuilder.prototype.zoomPreviewToPoint = function (clientX, clientY, targetScale, animate) {
    var viewport = this.els.previewZoomViewport;
    var transform = this.previewZoomTransform;
    if (!viewport || !transform) return;

    targetScale = this.clampPreviewZoomScale(targetScale);

    var rect = viewport.getBoundingClientRect();
    var originX = rect.left + rect.width / 2;
    var originY = rect.top + rect.height / 2;
    var dx = clientX - originX;
    var dy = clientY - originY;
    var ratio = transform.scale ? targetScale / transform.scale : 1;

    transform.x = dx - (dx - transform.x) * ratio;
    transform.y = dy - (dy - transform.y) * ratio;
    transform.scale = targetScale;
    this.clampPreviewZoomPan();
    this.applyPreviewZoomTransform(animate);
  };

  ProductBuilder.prototype.stepPreviewZoomAtPoint = function (clientX, clientY, delta) {
    var transform = this.previewZoomTransform;
    if (!transform || !delta) return;

    var scaleFactor = Math.exp(-delta * 0.002);
    this.zoomPreviewToPoint(clientX, clientY, transform.scale * scaleFactor, false);
  };

  ProductBuilder.prototype.togglePreviewZoomAtPoint = function (clientX, clientY) {
    var transform = this.previewZoomTransform;
    if (!transform) return;

    if (this.isPreviewZoomExpanded()) {
      transform.scale = transform.fitScale;
      transform.x = 0;
      transform.y = 0;
      this.applyPreviewZoomTransform(true);
      return;
    }

    this.zoomPreviewToPoint(clientX, clientY, transform.zoomScale, true);
  };

  ProductBuilder.prototype.finalizePreviewZoomCanvas = function () {
    var targetCanvas = this.els.previewZoomCanvas;
    if (!targetCanvas) return;

    targetCanvas.querySelectorAll('.product-builder__charm-on-canvas').forEach(function (charm) {
      charm.classList.remove('is-entering', 'is-settling');
    });
  };

  ProductBuilder.prototype.syncPreviewZoomContent = function () {
    var sourceCanvas = this.els.canvas;
    var targetCanvas = this.els.previewZoomCanvas;
    if (!sourceCanvas || !targetCanvas) return;

    var wasExpanded = this.isPreviewZoomExpanded();
    this.copyCanvasStylesForZoom(sourceCanvas, targetCanvas);

    while (targetCanvas.firstChild) {
      targetCanvas.removeChild(targetCanvas.firstChild);
    }

    Array.prototype.forEach.call(sourceCanvas.childNodes, function (node) {
      targetCanvas.appendChild(node.cloneNode(true));
    });

    this.finalizePreviewZoomCanvas();

    var sourceWidth = sourceCanvas.offsetWidth;
    var sourceHeight = sourceCanvas.offsetHeight;
    if (sourceWidth > 0 && sourceHeight > 0) {
      this.previewZoomBaseSize = {
        width: sourceWidth,
        height: sourceHeight
      };
    }
    if (sourceWidth > 0) {
      targetCanvas.style.width = sourceWidth + 'px';
    }
    if (sourceHeight > 0) {
      targetCanvas.style.height = sourceHeight + 'px';
    }

    this.ensurePreviewZoomCanvasResolution();
    this.applyPreviewZoomCharmShadow();

    var previewBackground = this.getPreviewColBackground();
    if (this.els.previewZoomOverlay) {
      if (previewBackground) {
        this.els.previewZoomOverlay.style.backgroundColor = previewBackground;
      } else {
        this.els.previewZoomOverlay.style.removeProperty('background-color');
      }
    }

    if (!this.previewZoomOpen || !this.previewZoomTransform) return;

    if (wasExpanded) {
      this.refreshPreviewZoomTransform(false);
      this.applyPreviewZoomFocusPan();
      this.clampPreviewZoomPan();
      this.applyPreviewZoomTransform(false);
    }
  };

  ProductBuilder.prototype.openPreviewZoom = function () {
    if (!this.hasPreviewZoom() || !this.els.previewZoomOverlay) return;

    var overlay = this.els.previewZoomOverlay;
    this.previewZoomOpen = true;
    overlay.hidden = false;
    overlay.setAttribute('aria-hidden', 'false');
    overlay.classList.add('is-preparing');
    this.root.classList.add('product-builder--preview-zoom-open');
    this.syncPreviewZoomContent();

    var self = this;
    requestAnimationFrame(function () {
      self.resetPreviewZoomTransform(true);
      overlay.classList.remove('is-preparing');
    });
  };

  ProductBuilder.prototype.closePreviewZoom = function () {
    if (!this.els.previewZoomOverlay) return;

    this.previewZoomOpen = false;
    this.previewZoomTransform = null;
    this.previewZoomGestureState = null;
    if (this.els.previewZoomCanvas) {
      this.els.previewZoomCanvas.dataset.zoomMultiplier = '1';
      this.els.previewZoomCanvas.classList.remove('product-builder__preview-zoom-canvas--high-res');
    }
    this.els.previewZoomOverlay.hidden = true;
    this.els.previewZoomOverlay.setAttribute('aria-hidden', 'true');
    this.els.previewZoomOverlay.classList.remove('is-preparing');
    this.root.classList.remove('product-builder--preview-zoom-open');
  };

  ProductBuilder.prototype.bindPreviewZoomGestures = function () {
    if (this.previewZoomGesturesBound || !this.els.previewZoomViewport) return;

    var self = this;
    var viewport = this.els.previewZoomViewport;
    var gestureState = {
      pointers: {},
      panStart: null,
      pinchStart: null,
      gestureZoomStart: null,
      moved: false
    };

    this.previewZoomGestureState = gestureState;
    this.previewZoomGesturesBound = true;

    function getActivePointerCount() {
      return Object.keys(gestureState.pointers).length;
    }

    function getPinchDistance() {
      var points = Object.keys(gestureState.pointers).map(function (id) {
        return gestureState.pointers[id];
      });
      if (points.length < 2) return 0;
      var dx = points[0].x - points[1].x;
      var dy = points[0].y - points[1].y;
      return Math.sqrt(dx * dx + dy * dy);
    }

    function getPinchCenter() {
      var points = Object.keys(gestureState.pointers).map(function (id) {
        return gestureState.pointers[id];
      });
      if (points.length < 2) return { x: 0, y: 0 };
      return {
        x: (points[0].x + points[1].x) / 2,
        y: (points[0].y + points[1].y) / 2
      };
    }

    viewport.addEventListener('pointerdown', function (event) {
      if (!self.previewZoomOpen || event.button > 0) return;
      if (event.target.closest('[data-builder-preview-zoom-close]')) return;

      viewport.setPointerCapture(event.pointerId);
      gestureState.pointers[event.pointerId] = { x: event.clientX, y: event.clientY };

      if (getActivePointerCount() === 1) {
        gestureState.panStart = {
          x: event.clientX,
          y: event.clientY,
          translateX: self.previewZoomTransform ? self.previewZoomTransform.x : 0,
          translateY: self.previewZoomTransform ? self.previewZoomTransform.y : 0
        };
        gestureState.pinchStart = null;
        gestureState.moved = false;
      } else if (getActivePointerCount() === 2 && self.previewZoomTransform) {
        gestureState.pinchStart = {
          distance: getPinchDistance(),
          scale: self.previewZoomTransform.scale,
          center: getPinchCenter()
        };
        gestureState.panStart = null;
        gestureState.moved = true;
      }
    });

    viewport.addEventListener('wheel', function (event) {
      if (!self.previewZoomOpen || !self.previewZoomTransform) return;

      event.preventDefault();
      gestureState.moved = true;
      self.stepPreviewZoomAtPoint(event.clientX, event.clientY, event.deltaY);
    }, { passive: false });

    viewport.addEventListener('gesturestart', function (event) {
      if (!self.previewZoomOpen || !self.previewZoomTransform) return;

      event.preventDefault();
      gestureState.gestureZoomStart = self.previewZoomTransform.scale;
      gestureState.moved = true;
    }, { passive: false });

    viewport.addEventListener('gesturechange', function (event) {
      if (!self.previewZoomOpen || !self.previewZoomTransform || gestureState.gestureZoomStart == null) return;

      event.preventDefault();
      var rect = viewport.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2;
      var centerY = rect.top + rect.height / 2;
      self.zoomPreviewToPoint(
        centerX,
        centerY,
        gestureState.gestureZoomStart * event.scale,
        false
      );
    }, { passive: false });

    viewport.addEventListener('gestureend', function () {
      gestureState.gestureZoomStart = null;
    }, { passive: false });

    viewport.addEventListener('pointermove', function (event) {
      if (!self.previewZoomOpen || !gestureState.pointers[event.pointerId] || !self.previewZoomTransform) return;

      gestureState.pointers[event.pointerId] = { x: event.clientX, y: event.clientY };

      if (getActivePointerCount() >= 2 && gestureState.pinchStart) {
        var distance = getPinchDistance();
        if (!distance) return;

        gestureState.moved = true;
        var center = getPinchCenter();
        var nextScale = gestureState.pinchStart.scale * (distance / gestureState.pinchStart.distance);
        self.zoomPreviewToPoint(center.x, center.y, nextScale, false);
        return;
      }

      if (getActivePointerCount() === 1 && gestureState.panStart) {
        var panDx = event.clientX - gestureState.panStart.x;
        var panDy = event.clientY - gestureState.panStart.y;

        if (Math.abs(panDx) > 2 || Math.abs(panDy) > 2) {
          gestureState.moved = true;
        }

        if (self.isPreviewZoomExpanded()) {
          viewport.classList.add('is-panning');
          self.previewZoomTransform.x = gestureState.panStart.translateX + panDx;
          self.previewZoomTransform.y = gestureState.panStart.translateY + panDy;
          self.clampPreviewZoomPan();
          self.applyPreviewZoomTransform(false);
        }
      }
    });

    function clearPointer(event) {
      delete gestureState.pointers[event.pointerId];
      if (getActivePointerCount() === 0) {
        gestureState.panStart = null;
        gestureState.pinchStart = null;
        viewport.classList.remove('is-panning');
      }
    }

    viewport.addEventListener('pointerup', function (event) {
      if (!self.previewZoomOpen) return;

      var isTap = gestureState.panStart &&
        !gestureState.moved &&
        Math.abs(event.clientX - gestureState.panStart.x) < 8 &&
        Math.abs(event.clientY - gestureState.panStart.y) < 8 &&
        getActivePointerCount() <= 1;

      clearPointer(event);

      if (!isTap) return;

      self.togglePreviewZoomAtPoint(event.clientX, event.clientY);
    });

    viewport.addEventListener('pointercancel', clearPointer);
  };

  ProductBuilder.prototype.isPreviewTopAligned = function () {
    return /^top/i.test(this.getPreviewImagePosition());
  };

  ProductBuilder.prototype.isPreviewEdgeToEdge = function () {
    var preview = this.getActivePreviewSettings();
    return preview.edge_to_edge === true;
  };

  ProductBuilder.prototype.getMaxSlotYPercent = function () {
    var maxY = 0;
    var placement = this.getActivePlacement() || {};
    var sources = [placement.slot_sets];

    (placement.slot_groups || []).forEach(function (group) {
      sources.push(group.slot_sets);
    });

    sources.forEach(function (slotSets) {
      if (!slotSets) return;
      Object.keys(slotSets).forEach(function (key) {
        (slotSets[key] || []).forEach(function (slot) {
          var y = parseFloat(slot && slot.y_percent);
          if (!isNaN(y) && y > maxY) maxY = y;
        });
      });
    });

    return maxY || 76;
  };

  ProductBuilder.prototype.getPreviewImageTransform = function () {
    var preview = this.getActivePreviewSettings();
    var isMobile = this.isPreviewMobileViewport();
    var offsetSource = isMobile && preview.image_offset_y_percent_mobile != null
      ? preview.image_offset_y_percent_mobile
      : preview.image_offset_y_percent;
    var scaleSource = isMobile && preview.image_scale_mobile != null
      ? preview.image_scale_mobile
      : preview.image_scale;
    var offsetY = parseFloat(offsetSource);
    var scale = parseFloat(scaleSource);

    if (isNaN(offsetY)) offsetY = 0;
    if (isNaN(scale) || scale <= 0) scale = 1;

    // Keep bottom hoop charms inside the canvas when using top-origin scale.
    if (this.isPreviewTopAligned()) {
      var slotCap = 96 / this.getMaxSlotYPercent();
      scale = Math.min(scale, slotCap);
    }

    return {
      offsetY: offsetY,
      scale: scale
    };
  };

  ProductBuilder.prototype.getPreviewImagePosition = function () {
    var preview = this.getActivePreviewSettings();
    var value = preview.image_position || preview.object_position;

    if (typeof value === 'string') {
      var normalized = value.trim().toLowerCase();
      if (normalized === 'top' || normalized === 'top center') return 'top center';
      if (normalized === 'center' || normalized === 'center center') return 'center center';
      if (normalized === 'bottom' || normalized === 'bottom center') return 'bottom center';
      if (value.trim()) return value.trim();
    }

    // Necklaces with hoop groups: pin preview to top of canvas (bracelets stay centred).
    if (this.hasSlotGroups()) return 'top center';

    return 'center center';
  };

  ProductBuilder.prototype.getVariantPreviewImage = function (variant, product) {
    var url = '';

    if (variant && variant.featured_image) {
      url = variant.featured_image.src || variant.featured_image;
    } else if (product && product.featured_image) {
      url = product.featured_image.src || product.featured_image;
    } else if (product && product.images && product.images.length) {
      url = product.images[0].src || product.images[0];
    }

    return this.resolveCharmPreviewImageUrl(url);
  };

  ProductBuilder.prototype.resolveCharmProductVariant = function (product, entry) {
    var variants = (product && product.variants) || [];
    if (!variants.length) return null;

    entry = entry || {};

    if (entry.variant_id != null) {
      var byId = variants.find(function (variant) {
        return Number(variant.id) === Number(entry.variant_id);
      });
      if (byId) return byId;
    }

    if (entry.variant_title) {
      var titleNeedle = String(entry.variant_title).trim().toLowerCase();
      var byTitle = variants.find(function (variant) {
        return String(variant.title || '').toLowerCase().indexOf(titleNeedle) !== -1;
      });
      if (byTitle) return byTitle;
    }

    var noChain = variants.find(function (variant) {
      return String(variant.title || '').toLowerCase().indexOf('no chain') !== -1;
    });
    if (noChain) return noChain;

    var purchasable = variants.find(function (variant) {
      return this.isVariantPurchasable(variant);
    }, this);
    if (purchasable) return purchasable;

    return variants[0];
  };

  ProductBuilder.prototype.buildCharmProductVariantEntry = function (product, entry) {
    var preferredVariant = this.resolveCharmProductVariant(product, entry);
    if (!preferredVariant) return null;

    var label = entry.label || product.title;
    var previewImage = entry.preview_image || this.getVariantPreviewImage(preferredVariant, product);
    var variantEntry = {
      id: preferredVariant.id,
      letter: label,
      title: preferredVariant.title,
      price: preferredVariant.price,
      available: preferredVariant.available,
      inventory_quantity: preferredVariant.inventory_quantity != null
        ? preferredVariant.inventory_quantity
        : null,
      inventory_management: preferredVariant.inventory_management || null,
      inventory_policy: preferredVariant.inventory_policy || 'deny',
      preview_image: previewImage,
      sku: preferredVariant.sku,
      design_token: entry.design_token || label
    };

    this.syncVariantInventory(variantEntry, preferredVariant);
    return variantEntry;
  };

  ProductBuilder.prototype.buildCharmTiles = function () {
    var self = this;
    var tiles = [];

    this.charmGroups.forEach(function (group) {
      var groupId = group.id || group.product_handle || 'group';
      var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

      if (groupType === 'products' && group.products && group.products.length) {
        group.products.forEach(function (product) {
          var tileSizePercent = product.size_percent != null
            ? product.size_percent
            : self.getConfigCharmSizePercent(product.product_handle, groupId);

          (product.variants || []).forEach(function (variant) {
            var label = product.label || product.product_title || variant.letter || variant.title;
            var previewImage = product.preview_image || variant.preview_image || '';
            var tile = {
              groupId: groupId,
              type: 'product',
              product_handle: product.product_handle,
              product_title: product.product_title,
              label: label,
              design_token: variant.design_token || product.design_token || label,
              id: variant.id,
              letter: label,
              title: variant.title,
              price: variant.price,
              preview_image: previewImage,
              preview_image_blank: product.preview_image_blank || '',
              sku: variant.sku,
              available: variant.available,
              inventory_quantity: variant.inventory_quantity,
              inventory_management: variant.inventory_management,
              inventory_policy: variant.inventory_policy,
              engraving: product.engraving || null,
              gallery_images: product.gallery_images || []
            };

            if (tileSizePercent != null) {
              tile.size_percent = tileSizePercent;
            }

            if (!self.isExcludedCharmTile(tile)) {
              tiles.push(tile);
            }
          });
        });
        return;
      }

      var letterSizePercent = group.size_percent != null
        ? group.size_percent
        : self.getConfigCharmSizePercent(group.product_handle, groupId);

      (group.variants || []).forEach(function (variant) {
        var tile = {
          groupId: groupId,
          type: 'letter',
          product_handle: group.product_handle,
          product_title: group.product_title,
          label: variant.letter || variant.title,
          design_token: variant.design_token || variant.letter || variant.title,
          id: variant.id,
          letter: variant.letter || variant.title,
          title: variant.title,
          price: variant.price,
          preview_image: variant.preview_image,
          sku: variant.sku,
          available: variant.available,
          inventory_quantity: variant.inventory_quantity,
          inventory_management: variant.inventory_management,
          inventory_policy: variant.inventory_policy
        };

        if (letterSizePercent != null) {
          tile.size_percent = letterSizePercent;
        }

        if (!self.isExcludedCharmTile(tile)) {
          tiles.push(tile);
        }
      });
    });

    return tiles;
  };

  ProductBuilder.prototype.syncCharmTiles = function () {
    this.charmTiles = this.buildCharmTiles();
  };

  ProductBuilder.prototype.getCharmDisplayToken = function (charm) {
    if (!charm) return '';

    if (charm.charmType === 'letter') {
      return normalizeDesignToken(charm.letter);
    }

    var label = normalizeDesignToken(charm.label || charm.letter);
    if (charm.engraving && charm.engraving.enabled && charm.engraving.letters) {
      return label + ' ' + normalizeDesignToken(charm.engraving.letters);
    }

    return label;
  };

  ProductBuilder.prototype.getCharmEngravingConfig = function (tileData) {
    if (!tileData) return null;

    if (tileData.engraving && tileData.engraving.enabled) {
      return tileData.engraving;
    }

    var handle = tileData.product_handle;
    if (!handle) return null;

    var groups = this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        if (entry.product_handle === handle && entry.engraving && entry.engraving.enabled) {
          return entry.engraving;
        }
      }
    }

    return null;
  };

  ProductBuilder.prototype.resolveBlankPreviewImage = function (product, entry) {
    var engraving = entry && entry.engraving;

    if (engraving && engraving.preview_image_blank) {
      return String(engraving.preview_image_blank);
    }

    if (entry && entry.preview_image_blank) {
      return String(entry.preview_image_blank);
    }

    var blankFromAlt = '';
    (product.images || []).forEach(function (image) {
      if (blankFromAlt) return;

      var alt = String(image.alt || '').toLowerCase();
      if (alt.indexOf('blank') !== -1
        || alt.indexOf('no engraving') !== -1
        || alt.indexOf('unengraved') !== -1) {
        blankFromAlt = image.src || image;
      }
    });

    return blankFromAlt;
  };

  ProductBuilder.prototype.getCharmBlankPreviewImage = function (tileData) {
    if (!tileData) return '';

    var config = this.getCharmEngravingConfig(tileData) || {};
    if (config.preview_image_blank) {
      return String(config.preview_image_blank);
    }

    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    if (liveTile.preview_image_blank) {
      return String(liveTile.preview_image_blank);
    }

    var handle = tileData.product_handle;
    if (!handle) return '';

    var groups = this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        if (entry.product_handle !== handle) continue;

        if (entry.preview_image_blank) {
          return String(entry.preview_image_blank);
        }

        if (entry.engraving && entry.engraving.preview_image_blank) {
          return String(entry.engraving.preview_image_blank);
        }

        return '';
      }
    }

    return '';
  };

  ProductBuilder.prototype.resolveEngraveGalleryImages = function (engraving, entry, product) {
    engraving = engraving || {};

    if (engraving.gallery === false) {
      return [];
    }

    if (engraving.gallery_images != null) {
      if (!Array.isArray(engraving.gallery_images)) {
        return [];
      }

      return engraving.gallery_images.map(function (url) {
        return String(url);
      }).filter(Boolean);
    }

    var images = (product && product.images ? product.images : []).map(function (image) {
      return image.src || image;
    }).filter(Boolean);

    if (images.length) {
      return images;
    }

    if (entry && entry.gallery_images && entry.gallery_images.length) {
      return entry.gallery_images.map(function (url) {
        return String(url);
      });
    }

    return [];
  };

  ProductBuilder.prototype.getProductGalleryImages = function (product, entry) {
    return this.resolveEngraveGalleryImages(entry && entry.engraving, entry, product);
  };

  ProductBuilder.prototype.getCharmEngravingGalleryImages = function (tileData, config) {
    var engraving = config || this.getCharmEngravingConfig(tileData) || {};

    if (engraving.gallery === false) {
      return [];
    }

    if (engraving.gallery_images != null) {
      if (!Array.isArray(engraving.gallery_images)) {
        return [];
      }

      return engraving.gallery_images.map(function (url) {
        return String(url);
      }).filter(Boolean);
    }

    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    if (liveTile.gallery_images && liveTile.gallery_images.length) {
      return liveTile.gallery_images.map(function (url) {
        return String(url);
      });
    }

    var handle = tileData.product_handle;
    if (!handle) return [];

    var groups = this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        if (entry.product_handle !== handle) continue;

        return this.resolveEngraveGalleryImages(entry.engraving, entry, null);
      }
    }

    return [];
  };

  ProductBuilder.prototype.destroyEngraveGallerySlider = function () {
    var track = this.els.engraveGalleryTrack;
    if (!track || typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) return;

    var $track = jQuery(track);
    if ($track.hasClass('slick-initialized')) {
      $track.slick('unslick');
    }
  };

  ProductBuilder.prototype.getEngraveGalleryCenterPadding = function () {
    var track = this.els.engraveGalleryTrack;
    if (!track) return '1.5rem';

    var inner = track.closest('.product-builder__engrave-tray-inner');
    if (!inner) return '1.5rem';

    var sidePadding = parseFloat(window.getComputedStyle(inner).paddingLeft);
    if (isNaN(sidePadding) || sidePadding <= 0) {
      return '1.5rem';
    }

    return sidePadding + 'px';
  };

  ProductBuilder.prototype.isEngraveGalleryEnabled = function () {
    return window.matchMedia('(min-width: 901px)').matches;
  };

  ProductBuilder.prototype.syncEngraveGalleryLayout = function () {
    if (!this.isEngraveGalleryEnabled()) return;

    var gallery = this.els.engraveGallery;
    var inner = this.els.engraveTray
      ? this.els.engraveTray.querySelector('.product-builder__engrave-tray-inner')
      : null;

    if (!gallery || gallery.hidden || !inner) return;

    gallery.style.removeProperty('--engrave-slide-max-height');

    var track = this.els.engraveGalleryTrack;
    if (track) {
      track.style.height = '';
    }

    var reserved = 0;
    var childNodes = inner.children;

    for (var i = 0; i < childNodes.length; i++) {
      var child = childNodes[i];
      if (child === gallery || child.hidden) continue;

      var childStyle = window.getComputedStyle(child);
      if (childStyle.display === 'none') continue;

      reserved += child.offsetHeight;
      reserved += parseFloat(childStyle.marginTop) || 0;
      reserved += parseFloat(childStyle.marginBottom) || 0;
    }

    var innerStyle = window.getComputedStyle(inner);
    reserved += parseFloat(innerStyle.paddingTop) || 0;
    reserved += parseFloat(innerStyle.paddingBottom) || 0;

    var galleryStyle = window.getComputedStyle(gallery);
    reserved += parseFloat(galleryStyle.marginTop) || 0;
    reserved += parseFloat(galleryStyle.marginBottom) || 0;

    var dots = track ? track.querySelector('.slick-dots') : null;
    if (dots) {
      var dotsStyle = window.getComputedStyle(dots);
      reserved += dots.offsetHeight
        + (parseFloat(dotsStyle.marginTop) || 0)
        + (parseFloat(dotsStyle.marginBottom) || 0);
    }

    var innerHeight = inner.clientHeight || window.innerHeight;
    var maxSlideHeight = Math.max(120, innerHeight - reserved);

    gallery.style.setProperty('--engrave-slide-max-height', maxSlideHeight + 'px');

    if (track && typeof jQuery !== 'undefined' && jQuery.fn && jQuery.fn.slick) {
      var $track = jQuery(track);
      if ($track.hasClass('slick-initialized')) {
        $track.slick('setPosition');
      }
    }
  };

  ProductBuilder.prototype.initEngraveGallerySlider = function (slideCount) {
    var track = this.els.engraveGalleryTrack;
    if (!track || typeof jQuery === 'undefined' || !jQuery.fn || !jQuery.fn.slick) return;

    this.destroyEngraveGallerySlider();

    var $track = jQuery(track);
    $track.slick({
      autoplay: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: slideCount > 1,
      draggable: true,
      swipe: true,
      swipeToSlide: true,
      infinite: false,
      adaptiveHeight: false,
      touchMove: true,
      centerMode: slideCount > 1,
      centerPadding: this.getEngraveGalleryCenterPadding(),
      focusOnSelect: false
    });

    var self = this;
    requestAnimationFrame(function () {
      self.syncEngraveGalleryLayout();
      requestAnimationFrame(function () {
        if ($track.hasClass('slick-initialized')) {
          $track.slick('setPosition');
        }
      });
    });
  };

  ProductBuilder.prototype.renderEngraveGallery = function (tileData, config) {
    if (!this.els.engraveGallery || !this.els.engraveGalleryTrack) return;

    this.destroyEngraveGallerySlider();
    this.els.engraveGalleryTrack.innerHTML = '';

    if (!this.isEngraveGalleryEnabled()) {
      this.els.engraveGallery.hidden = true;
      return;
    }

    var images = this.getCharmEngravingGalleryImages(tileData, config || {});

    if (!images.length) {
      this.els.engraveGallery.hidden = true;
      return;
    }

    var label = tileData.label || tileData.product_title || 'Engraving example';
    images.forEach(function (url, index) {
      var slide = document.createElement('div');
      slide.className = 'product-builder__engrave-gallery-slide';

      var img = configureBuilderImage(document.createElement('img'));
      img.src = url;
      img.alt = label + ' example ' + (index + 1);
      img.loading = index === 0 ? 'eager' : 'lazy';
      slide.appendChild(img);
      this.els.engraveGalleryTrack.appendChild(slide);
    }, this);

    this.els.engraveGallery.hidden = false;
    this.initEngraveGallerySlider(images.length);

    var self = this;
    images.forEach(function (url, index) {
      var img = self.els.engraveGalleryTrack
        && self.els.engraveGalleryTrack.querySelectorAll('.product-builder__engrave-gallery-slide img')[index];
      if (img && !img.complete) {
        img.addEventListener('load', function () {
          self.syncEngraveGalleryLayout();
        }, { once: true });
      }
    });
  };

  ProductBuilder.prototype.normalizeEngravingLetters = function (value, maxLetters) {
    var letters = String(value || '')
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .slice(0, maxLetters);

    return letters;
  };

  ProductBuilder.prototype.getCharmReviewSubtitle = function (charm) {
    if (!charm) return '';

    if (charm.engraving && charm.engraving.enabled && charm.engraving.letters) {
      return 'Engraving: ' + charm.engraving.letters;
    }

    return charm.letter || charm.label || '';
  };

  ProductBuilder.prototype.buildCharmDataFromTile = function (tileData, engravingState) {
    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    var previewImage = liveTile.preview_image;

    if (!engravingState) {
      var blankPreview = this.getCharmBlankPreviewImage(liveTile);
      if (blankPreview) {
        previewImage = blankPreview;
      }
    }

    return {
      instanceId: generateBuilderId(),
      id: liveTile.id,
      groupId: liveTile.groupId,
      charmType: liveTile.type || 'letter',
      product_handle: liveTile.product_handle,
      product_title: liveTile.product_title,
      letter: liveTile.letter || liveTile.title,
      label: liveTile.label || liveTile.letter || liveTile.title,
      design_token: liveTile.design_token || liveTile.letter || liveTile.title,
      title: liveTile.title,
      price: liveTile.price,
      preview_image: previewImage,
      sku: liveTile.sku,
      size_percent: liveTile.size_percent != null ? liveTile.size_percent : null,
      engraving: engravingState || null
    };
  };

  ProductBuilder.prototype.addCharmToSelection = function (charmData) {
    if (this.hasSlotGroups()) {
      var slotIndex = this.getNextAddIndex();
      if (slotIndex === -1) return false;
      this.ensureSlotStorage();
      this.selectedCharms[slotIndex] = charmData;
    } else {
      this.selectedCharms.push(charmData);
    }

    this.renderCharmGrid();
    this.renderPreview();
    this.updateEditButtonVisibility();

    if (this.getSelectedCharmCount() >= this.getMinCharms()) {
      this.clearCharmValidation();
    }

    if (this.step === 'edit') {
      this.renderSelectedCharmsTray();
    }

    return true;
  };

  ProductBuilder.prototype.showEngraveError = function (message) {
    if (!this.els.engraveError) return;
    if (message) {
      this.els.engraveError.textContent = message;
      this.els.engraveError.hidden = false;
    } else {
      this.els.engraveError.hidden = true;
      this.els.engraveError.textContent = '';
    }
  };

  ProductBuilder.prototype.closeCharmEngravingPanel = function () {
    this.pendingEngraveTile = null;
    this.showEngraveError('');
    if (this.els.engraveInput) {
      this.els.engraveInput.value = '';
    }
    if (this.els.engraveGallery) {
      this.els.engraveGallery.hidden = true;
      this.els.engraveGallery.style.removeProperty('--engrave-slide-max-height');
    }
    if (this.els.engraveGalleryTrack) {
      this.destroyEngraveGallerySlider();
      this.els.engraveGalleryTrack.innerHTML = '';
      this.els.engraveGalleryTrack.style.height = '';
    }
    if (this.root) {
      this.root.classList.remove('product-builder--engraving-open');
    }
  };

  ProductBuilder.prototype.renderEngraveNotes = function (config) {
    if (!this.els.engraveNotes) return;

    var notes = config && config.things_to_know;
    if (notes === false) {
      this.els.engraveNotes.hidden = true;
      return;
    }

    var title = (notes && notes.title) || 'Things to know:';
    var items = (notes && notes.items) || [
      'Hand engraved and delivered within 2-3 weeks',
      'Personalised products can\'t be returned or refunded.'
    ];

    if (!items || !items.length) {
      this.els.engraveNotes.hidden = true;
      return;
    }

    if (this.els.engraveNotesTitle) {
      this.els.engraveNotesTitle.textContent = title;
    }

    if (this.els.engraveNotesList) {
      this.els.engraveNotesList.innerHTML = '';
      var self = this;
      items.forEach(function (item) {
        var li = document.createElement('li');
        li.textContent = item;
        self.els.engraveNotesList.appendChild(li);
      });
    }

    this.els.engraveNotes.hidden = false;
  };

  ProductBuilder.prototype.openCharmEngravingPanel = function (tileData) {
    var config = this.getCharmEngravingConfig(tileData);
    if (!config) return false;

    var maxLetters = parsePositiveInt(config.max_letters);
    if (maxLetters === null) maxLetters = 3;

    this.pendingEngraveTile = tileData;
    this.showEngraveError('');

    if (this.els.engraveTitle) {
      this.els.engraveTitle.textContent = config.title || 'Hand Engraving';
    }

    if (this.els.engraveHint) {
      var hintParts = [];

      if (config.hint) {
        hintParts.push(config.hint);
      }

      if (config.preview_note && config.preview_note !== false) {
        hintParts.push(String(config.preview_note));
      }

      if (hintParts.length) {
        this.els.engraveHint.textContent = hintParts.join(' ');
        this.els.engraveHint.hidden = false;
      } else {
        this.els.engraveHint.textContent = '';
        this.els.engraveHint.hidden = true;
      }
    }

    if (this.els.engraveMax) {
      this.els.engraveMax.textContent = config.max_label
        || ('Max. ' + maxLetters + ' character' + (maxLetters === 1 ? '' : 's'));
    }

    if (this.els.engraveLabel) {
      var fieldLabel = config.input_label || 'Enter letters here';
      this.els.engraveLabel.textContent = fieldLabel;
    }

    if (this.els.engraveInput) {
      this.els.engraveInput.value = '';
      this.els.engraveInput.maxLength = maxLetters;
      this.els.engraveInput.placeholder = config.placeholder || config.input_label || 'Enter letters here';
    }

    if (this.els.engraveSkip) {
      this.els.engraveSkip.hidden = config.allow_skip === false;
      this.els.engraveSkip.textContent = config.skip_label || 'No engraving';
    }

    if (this.els.engraveConfirm) {
      this.els.engraveConfirm.textContent = config.confirm_label || 'Add charm';
    }

    this.renderEngraveNotes(config);

    if (this.root) {
      this.root.classList.add('product-builder--engraving-open');
    }

    this.renderEngraveGallery(tileData, config);
    this.syncEngraveGalleryLayout();

    if (this.els.engraveInput) {
      this.els.engraveInput.focus();
    }

    return true;
  };

  ProductBuilder.prototype.confirmCharmEngraving = function (withEngraving) {
    if (!this.pendingEngraveTile) return;

    var tileData = this.pendingEngraveTile;
    var config = this.getCharmEngravingConfig(tileData) || {};
    var maxLetters = parsePositiveInt(config.max_letters);
    if (maxLetters === null) maxLetters = 3;

    var engravingState = null;

    if (withEngraving) {
      var letters = this.normalizeEngravingLetters(
        this.els.engraveInput ? this.els.engraveInput.value : '',
        maxLetters
      );

      if (!letters.length) {
        this.showEngraveError('Please enter at least 1 letter.');
        return;
      }

      engravingState = {
        enabled: true,
        letters: letters,
        option: 'Letters'
      };
    }

    var charmData = this.buildCharmDataFromTile(tileData, engravingState);
    if (!this.canAddCharmVariant(tileData)) {
      this.showEngraveError('This charm is no longer available.');
      return;
    }

    this.closeCharmEngravingPanel();
    this.addCharmToSelection(charmData);
  };

  ProductBuilder.prototype.getSlotPositionInGroup = function (slotIndex) {
    var group = this.getSlotGroupForIndex(slotIndex);
    if (!group) return 0;

    var order = this.getSlotFillOrder(group);
    var position = order.indexOf(slotIndex);
    return position === -1 ? 0 : position + 1;
  };

  ProductBuilder.prototype.getSlotPlacementLabel = function (slotIndex) {
    var group = this.getSlotGroupForIndex(slotIndex);
    if (!group) return '';

    var groupLabel = (group.label || group.id || 'Hoop').trim();
    if (this.countCharmsInGroup(group) <= 1) {
      return groupLabel;
    }

    var position = this.getSlotPositionInGroup(slotIndex);
    return groupLabel + ' · ' + position;
  };

  ProductBuilder.prototype.getDesignLabel = function () {
    if (!this.hasSlotGroups()) {
      return this.getSelectedCharmsList().map(function (c) {
        return normalizeDesignToken(c.design_token || c.letter);
      }).join('');
    }

    var entries = [];
    this.forEachSelectedCharm(function (charm, slotIndex) {
      entries.push({
        token: this.getCharmDisplayToken(charm),
        placement: this.getSlotPlacementLabel(slotIndex)
      });
    }, this);

    if (typeof theme !== 'undefined' && typeof theme.formatBuilderSlotDesign === 'function') {
      return theme.formatBuilderSlotDesign(entries);
    }

    return entries.map(function (entry) {
      return entry.token + ' (' + entry.placement + ')';
    }).join(' · ');
  };

  ProductBuilder.prototype.getComplementaryCharmCount = function () {
    var pool = this.data.pool || {};
    var sources = [
      pool.complementary_charms,
      this.config.complementary_charms,
      this.config.complementary_included,
      this.charmGroup && this.charmGroup.complementary_included,
      this.charmGroup && this.charmGroup.complementary_charms
    ];

    for (var i = 0; i < sources.length; i++) {
      var count = parsePositiveInt(sources[i]);
      if (count !== null) return count;
    }

    return 0;
  };

  ProductBuilder.prototype.getComplementaryLabel = function () {
    return (this.config.complementary_label || 'Complimentary').trim();
  };

  ProductBuilder.prototype.getBespokeCharmsConfig = function () {
    var cfg = this.config && this.config.bespoke_charms;
    if (!cfg || cfg.enabled !== true) return null;
    return cfg;
  };

  ProductBuilder.prototype.getBespokeCharmsPrompt = function () {
    var cfg = this.getBespokeCharmsConfig();
    if (!cfg) return '';

    if (cfg.prompt) return String(cfg.prompt).trim();

    return 'Need more than ' + this.getPoolMax() + ' charms?';
  };

  ProductBuilder.prototype.getBespokeCharmsMessageHtml = function () {
    var cfg = this.getBespokeCharmsConfig();
    if (!cfg || !cfg.message) return '';

    var message = String(cfg.message);
    var linkText = (cfg.concierge_text || 'concierge').trim();
    var linkUrl = (cfg.concierge_url || '/pages/otiumberg-concierge').trim();
    var parts = message.split(linkText);

    if (parts.length === 2 && linkText) {
      return parts[0] + '<a href="' + linkUrl + '" target="_blank" rel="noopener noreferrer">' + linkText + '</a>' + parts[1];
    }

    return message;
  };

  ProductBuilder.prototype.closeBespokeCharmsMessage = function () {
    if (!this.els.bespokeCharmsToggle || !this.els.bespokeCharmsMessage) return;

    this.els.bespokeCharmsToggle.setAttribute('aria-expanded', 'false');
    this.els.bespokeCharmsMessage.hidden = true;
  };

  ProductBuilder.prototype.updateBespokeCharmsNote = function () {
    if (!this.els.bespokeCharms || !this.els.bespokeCharmsToggle || !this.els.bespokeCharmsMessage) {
      return;
    }

    var cfg = this.getBespokeCharmsConfig();
    var atMax = this.getSelectedCharmCount() >= this.getPoolMax();
    var show = Boolean(cfg) && atMax && (this.step === 'choose' || this.step === 'edit');

    if (!show) {
      this.els.bespokeCharms.hidden = true;
      this.closeBespokeCharmsMessage();
      return;
    }

    this.els.bespokeCharmsToggle.textContent = this.getBespokeCharmsPrompt();
    this.els.bespokeCharmsMessage.innerHTML = this.getBespokeCharmsMessageHtml();
    this.els.bespokeCharms.hidden = false;
  };

  ProductBuilder.prototype.isComplementaryCharmIndex = function (index) {
    return index < this.getComplementaryCharmCount();
  };

  ProductBuilder.prototype.isNextCharmComplementary = function () {
    return this.getSelectedCharmCount() < this.getComplementaryCharmCount();
  };

  ProductBuilder.prototype.getTotalPrice = function () {
    var self = this;
    var base = this.getBaseVariant();
    var total = base ? Number(base.price) : 0;
    this.forEachSelectedCharm(function (charm, slotIndex, sequence) {
      if (!self.isComplementaryCharmIndex(sequence)) {
        total += Number(charm.price) || 0;
      }
    });
    this.getCartExtras().forEach(function (extra) {
      total += self.getCartExtraUnitPrice(extra) * self.getCartExtraQuantity(extra);
    });
    return total;
  };

  ProductBuilder.prototype.setPageScrollLock = function (lock) {
    var html = document.documentElement;
    var body = document.body;

    if (lock) {
      if (this.scrollLockActive) return;

      this.scrollLockScrollY = window.scrollY || window.pageYOffset || 0;
      this.scrollbarGap = window.innerWidth - html.clientWidth;

      html.classList.add('product-builder-open');
      body.classList.add('product-builder-open');
      body.style.top = '-' + this.scrollLockScrollY + 'px';

      if (this.scrollbarGap > 0) {
        body.style.paddingRight = this.scrollbarGap + 'px';
      }

      this.scrollLockActive = true;
      return;
    }

    if (!this.scrollLockActive) return;

    html.classList.remove('product-builder-open');
    body.classList.remove('product-builder-open');
    body.style.top = '';
    body.style.paddingRight = '';
    window.scrollTo(0, this.scrollLockScrollY || 0);

    this.scrollLockActive = false;
    this.scrollLockScrollY = 0;
    this.scrollbarGap = 0;
  };

  ProductBuilder.PANEL_TRANSITION_MS = 680;
  ProductBuilder.PANEL_MOBILE_MAX_WIDTH = 900;

  ProductBuilder.prototype.shouldAnimatePanelStep = function () {
    return window.matchMedia(
      '(min-width: ' + (ProductBuilder.PANEL_MOBILE_MAX_WIDTH + 1) + 'px)'
    ).matches;
  };

  ProductBuilder.prototype.isPanelStepTransition = function (fromStep, toStep) {
    if (!this.shouldAnimatePanelStep()) return false;

    return (fromStep === 'choose' || fromStep === 'review') &&
      (toStep === 'choose' || toStep === 'review') &&
      fromStep !== toStep;
  };

  ProductBuilder.prototype.shouldAnimateBuilderOpen = function () {
    return !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  };

  ProductBuilder.prototype.isBuilderOpenTransition = function (fromStep, toStep) {
    return fromStep === 'product' && toStep === 'choose';
  };

  ProductBuilder.prototype.beginBuilderOpenTransition = function () {
    if (this.root) {
      this.root.classList.add('product-builder--opening');
    }
  };

  ProductBuilder.prototype.endBuilderOpenTransition = function () {
    if (this.root) {
      this.root.classList.remove('product-builder--opening');
    }
  };

  ProductBuilder.prototype.playBuilderOpenTransition = function () {
    var self = this;

    this.beginBuilderOpenTransition();

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        self.endBuilderOpenTransition();
      });
    });
  };

  ProductBuilder.prototype.beginPanelStepTransition = function (toStep) {
    var stack = this.els.panelStack;
    if (!stack) return;

    var currentHeight = stack.offsetHeight;
    var incomingPanel = toStep === 'review' ? this.els.panelReview : this.els.panelChoose;
    var incomingHeight = incomingPanel ? incomingPanel.scrollHeight : 0;

    stack.style.setProperty(
      '--panel-stack-height',
      Math.max(currentHeight, incomingHeight) + 'px'
    );
    stack.classList.add('is-panel-transitioning');
  };

  ProductBuilder.prototype.endPanelStepTransition = function () {
    var stack = this.els.panelStack;
    if (!stack) return;

    stack.classList.remove('is-panel-transitioning');
    stack.style.removeProperty('--panel-stack-height');
  };

  ProductBuilder.prototype.setStep = function (step) {
    var isReview = step === 'review';
    var isEdit = step === 'edit';
    var isBuilder = step === 'choose' || step === 'review' || isEdit;
    var fromStep = this.step;
    var panelTransition = this.isPanelStepTransition(fromStep, step);
    var openTransition = this.isBuilderOpenTransition(fromStep, step) && this.shouldAnimateBuilderOpen();

    if (this.root && this.root.classList.contains('product-builder--engraving-open')) {
      this.closeCharmEngravingPanel();
    }

    if (openTransition) {
      this.beginBuilderOpenTransition();
    }

    if (isReview) {
      this.renderReview();
      this.clearCharmValidation();
    }

    if (panelTransition) {
      this.beginPanelStepTransition(step);
      clearTimeout(this.panelTransitionTimer);
    }

    this.step = step;
    this.root.setAttribute('data-step', step);

    if (isBuilder) {
      this.applyPreviewAppearance();
    }

    if (this.root) {
      this.root.hidden = !isBuilder;
    }
    this.setPageScrollLock(isBuilder);

    if (this.els.workspace) {
      this.els.workspace.hidden = !isBuilder;
    }

    if (this.els.panelChoose) {
      this.els.panelChoose.setAttribute('aria-hidden', isReview ? 'true' : 'false');
    }
    if (this.els.panelReview) {
      this.els.panelReview.setAttribute('aria-hidden', isReview ? 'false' : 'true');
    }
    if (this.els.reviewBtn) {
      this.els.reviewBtn.hidden = isReview;
    }
    if (this.els.addToBagBtn) {
      this.els.addToBagBtn.hidden = !isReview;
    }
    this.updateEditButtonVisibility();
    if (this.els.runningTotal) {
      this.els.runningTotal.hidden = !(step === 'choose' || step === 'review' || step === 'edit');
    }
    if (this.els.thingsToKnow) {
      this.els.thingsToKnow.hidden = step !== 'review';
    }

    if (!isReview) {
      this.updateRunningTotal();
    }
    this.updateComplementaryNote();
    this.updateBespokeCharmsNote();
    this.updateEditHint();

    if (panelTransition) {
      var self = this;
      this.panelTransitionTimer = setTimeout(function () {
        self.endPanelStepTransition();
      }, ProductBuilder.PANEL_TRANSITION_MS);
    }

    if (openTransition) {
      this.playBuilderOpenTransition();
    }

    if (step !== 'choose' && step !== 'edit') {
      this.closePreviewZoom();
    }
    this.updatePreviewZoomButtonVisibility();
    this.updatePreviewLayoutToggle();
  };

  ProductBuilder.prototype.samePreviewImageUrl = function (a, b) {
    if (!a || !b) return false;
    if (a === b) return true;
    try {
      return new URL(a, window.location.href).href === new URL(b, window.location.href).href;
    } catch (err) {
      return false;
    }
  };

  ProductBuilder.prototype.cancelBaseImageFade = function () {
    if (this.baseImageFadeTimer) {
      clearTimeout(this.baseImageFadeTimer);
      this.baseImageFadeTimer = null;
    }

    if (this.baseImageFadePreload) {
      this.baseImageFadePreload.onload = null;
      this.baseImageFadePreload.onerror = null;
      this.baseImageFadePreload = null;
    }

    if (this.baseImageFadeOutgoingHandler && this.els.baseImage) {
      this.els.baseImage.removeEventListener('transitionend', this.baseImageFadeOutgoingHandler);
      this.baseImageFadeOutgoingHandler = null;
    }

    var incoming = this.els.baseImageIncoming;
    if (incoming && incoming.classList.contains('is-visible')) {
      // Keep the already-visible frame instead of snapping back.
      this.promoteBaseImageIncoming();
    } else {
      if (incoming && incoming.parentNode) {
        incoming.parentNode.removeChild(incoming);
      }
      this.els.baseImageIncoming = null;

      if (this.els.baseImage) {
        this.els.baseImage.classList.remove('is-fading-out');
        this.els.baseImage.style.removeProperty('opacity');
        this.els.baseImage.style.removeProperty('z-index');
      }
    }

    this.baseImageFadeToken = null;
  };

  ProductBuilder.prototype.promoteBaseImageIncoming = function () {
    var incoming = this.els.baseImageIncoming;
    var outgoing = this.els.baseImage;
    if (!incoming) return outgoing || null;

    if (this.baseImageFadeOutgoingHandler && outgoing) {
      outgoing.removeEventListener('transitionend', this.baseImageFadeOutgoingHandler);
      this.baseImageFadeOutgoingHandler = null;
    }

    incoming.classList.remove(
      'product-builder__base-image--incoming',
      'is-visible',
      'is-fading-out'
    );
    incoming.style.removeProperty('opacity');
    incoming.style.removeProperty('z-index');
    incoming.removeAttribute('aria-hidden');
    incoming.setAttribute('data-builder-base-image', '');

    if (outgoing) {
      outgoing.removeAttribute('data-builder-base-image');
      if (outgoing.parentNode) {
        outgoing.parentNode.removeChild(outgoing);
      }
    }

    this.els.baseImage = incoming;
    this.els.baseImageIncoming = null;
    return incoming;
  };

  ProductBuilder.prototype.usesBaseImagesByCount = function () {
    return !!this.getBaseImagesByCountMap(this.getActivePreviewLayout());
  };

  ProductBuilder.prototype.optimizeShopifyImageUrl = function (url, options) {
    if (!url) return '';
    var fullUrl = String(url);
    if (fullUrl.indexOf('cdn.shopify.com') === -1) return fullUrl;

    options = options || {};
    var width = options.width || 1600;
    var format = options.format === undefined ? 'webp' : options.format;

    if (!/[?&]width=/.test(fullUrl)) {
      fullUrl += (fullUrl.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }
    if (format && !/[?&]format=/.test(fullUrl)) {
      fullUrl += (fullUrl.indexOf('?') === -1 ? '?' : '&') + 'format=' + format;
    }

    return fullUrl;
  };

  ProductBuilder.prototype.getRawBaseImagesByCount = function (layoutId) {
    return this.getBaseImagesByCountMap(layoutId) || {};
  };

  ProductBuilder.prototype.preloadPreviewImage = function (url) {
    var self = this;
    if (!url) return Promise.resolve('');

    this.baseImagePreloadCache = this.baseImagePreloadCache || {};
    var cached = this.baseImagePreloadCache[url];
    if (cached && cached.complete && cached.naturalWidth) {
      return Promise.resolve(url);
    }

    return new Promise(function (resolve) {
      var img = cached || new Image();
      self.baseImagePreloadCache[url] = img;

      var finish = function () {
        resolve(url);
      };

      img.onload = finish;
      img.onerror = function () {
        var fallback = String(url).replace(/([?&])format=webp(&)?/, function (match, sep, trailing) {
          return trailing ? sep : '';
        }).replace(/[?&]$/, '');
        if (fallback && fallback !== url && !self.baseImagePreloadCache[fallback]) {
          self.preloadPreviewImage(fallback).then(resolve);
          return;
        }
        finish();
      };

      img.src = url;
      if (img.complete && img.naturalWidth) {
        finish();
      }
    });
  };

  ProductBuilder.prototype.preloadBaseImagesByCount = function () {
    var self = this;
    var byCount = this.getRawBaseImagesByCount(this.getActivePreviewLayout());
    Object.keys(byCount).forEach(function (key) {
      var url = self.optimizeShopifyImageUrl(byCount[key]);
      if (url) self.preloadPreviewImage(url);
    });
  };

  ProductBuilder.prototype.updateBasePreview = function (options) {
    options = options || {};
    var previewUrl = this.getBasePreviewImageUrl();
    var img = this.els.baseImage;
    if (!img || !previewUrl) return;

    var currentUrl = img.getAttribute('src') || img.src || '';
    if (this.samePreviewImageUrl(currentUrl, previewUrl)) {
      return;
    }

    var shouldFade = options.animate !== false
      && this.usesBaseImagesByCount()
      && currentUrl
      && this.shouldAnimateBuilderOpen();

    if (!shouldFade) {
      this.cancelBaseImageFade();
      img = this.els.baseImage;
      if (img) img.src = previewUrl;
      return;
    }

    this.crossfadeBasePreview(previewUrl);
  };

  ProductBuilder.prototype.crossfadeBasePreview = function (previewUrl) {
    var self = this;
    var img = this.els.baseImage;
    var canvas = this.root && this.root.querySelector('[data-builder-canvas]');
    if (!img || !canvas || !previewUrl) return;

    this.cancelBaseImageFade();
    img = this.els.baseImage;
    if (!img) return;

    var token = String(Date.now()) + '-' + Math.random().toString(36).slice(2, 8);
    this.baseImageFadeToken = token;

    var preload = new Image();
    this.baseImageFadePreload = preload;

    var startFade = function () {
      if (self.baseImageFadeToken !== token || self.baseImageFadePreload !== preload) return;
      self.baseImageFadePreload = null;

      img = self.els.baseImage;
      if (!img || !self.root) return;

      var liveCanvas = self.root.querySelector('[data-builder-canvas]');
      if (!liveCanvas) return;

      var incoming = configureBuilderImage(document.createElement('img'));
      incoming.className = 'product-builder__base-image product-builder__base-image--incoming';
      incoming.alt = img.alt || '';
      incoming.width = img.width || 800;
      incoming.height = img.height || 800;
      incoming.draggable = false;
      incoming.src = previewUrl;
      incoming.style.objectPosition = img.style.objectPosition || window.getComputedStyle(img).objectPosition;
      incoming.setAttribute('aria-hidden', 'true');

      liveCanvas.insertBefore(incoming, img.nextSibling);
      self.els.baseImageIncoming = incoming;

      var finished = false;
      var finish = function () {
        if (finished || self.baseImageFadeToken !== token) return;
        finished = true;

        if (self.baseImageFadeTimer) {
          clearTimeout(self.baseImageFadeTimer);
          self.baseImageFadeTimer = null;
        }

        self.promoteBaseImageIncoming();
        self.baseImageFadeToken = null;

        if (self.previewZoomOpen) {
          self.syncPreviewZoomContent();
        }
      };

      self.baseImageFadeOutgoingHandler = function (event) {
        if (event.target !== img || event.propertyName !== 'opacity') return;
        finish();
      };
      img.addEventListener('transitionend', self.baseImageFadeOutgoingHandler);

      // Fallback if transitionend doesn't fire (e.g. reduced motion / display none).
      self.baseImageFadeTimer = setTimeout(finish, 450);

      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (self.baseImageFadeToken !== token) return;
          img.classList.add('is-fading-out');
          incoming.classList.add('is-visible');
        });
      });
    };

    preload.onload = startFade;
    preload.onerror = function () {
      if (self.baseImageFadeToken !== token) return;
      self.cancelBaseImageFade();
      if (self.els.baseImage) self.els.baseImage.src = previewUrl;
    };
    preload.src = previewUrl;

    if (preload.complete) {
      startFade();
    }
  };

  ProductBuilder.prototype.getBaseImagesByCountMap = function (layoutId) {
    var preview = this.config.preview || {};
    var layouts = preview.layouts || {};
    var layout = layoutId && layouts[layoutId] ? layouts[layoutId] : null;

    if (layout && layout.base_images_by_count && typeof layout.base_images_by_count === 'object') {
      return layout.base_images_by_count;
    }

    if (preview.base_images_by_count && typeof preview.base_images_by_count === 'object') {
      return preview.base_images_by_count;
    }

    return null;
  };

  ProductBuilder.prototype.getBasePreviewImageUrlByCount = function (layoutId) {
    var byCount = this.getBaseImagesByCountMap(layoutId);
    if (!byCount) return '';

    var count = this.getSelectedCharmCount();
    var exact = byCount[String(count)];
    if (exact) return this.optimizeShopifyImageUrl(exact);

    // Prefer the nearest lower count so removing charms still shows a valid base.
    for (var i = count - 1; i >= 0; i--) {
      if (byCount[String(i)]) return this.optimizeShopifyImageUrl(byCount[String(i)]);
    }

    if (byCount['0']) return this.optimizeShopifyImageUrl(byCount['0']);
    return '';
  };

  ProductBuilder.prototype.getBasePreviewImageUrlForLayout = function (layoutId) {
    var byCountUrl = this.getBasePreviewImageUrlByCount(layoutId);
    if (byCountUrl) {
      return byCountUrl;
    }

    var images = this.getBasePreviewImages();

    if (layoutId && images[layoutId]) {
      return images[layoutId];
    }

    if (images.line) {
      return images.line;
    }

    var variant = this.getBaseVariant();
    if (variant && variant.featured_image) {
      return variant.featured_image;
    }

    return (this.data.base && this.data.base.preview_image) || '';
  };

  ProductBuilder.prototype.getBasePreviewImageUrl = function () {
    return this.getBasePreviewImageUrlForLayout(this.getActivePreviewLayout());
  };

  ProductBuilder.prototype.renderCharmGrid = function () {
    var self = this;
    var grid = this.els.charmGrid;
    if (!grid || !this.hasCharmCatalog()) return;

    if (this.els.panelTitle) {
      this.els.panelTitle.textContent = this.getPanelTitle();
    }

    this.updateComplementaryNote();
    this.updateBespokeCharmsNote();
    this.syncCharmSelectorInputUI();

    if (this.isCharmSelectorInputEnabled()) {
      grid.innerHTML = '';
      return;
    }

    grid.innerHTML = '';
    grid.style.gridTemplateColumns = 'repeat(' + this.getGridColumns() + ', minmax(0, 1fr))';

    var atMax = self.getSelectedCharmCount() >= self.getPoolMax();

    this.charmTiles.forEach(function (tileData) {
      var hasPreview = Boolean(tileData.preview_image);
      var isAvailable = self.isVariantPurchasable(tileData) && hasPreview;
      var selectedCount = countCharmsForVariant(self.selectedCharms, tileData.id);
      var stockCap = self.getVariantStockCap(tileData);
      var atStockCap = stockCap !== null && selectedCount >= stockCap;
      var tileLabel = self.getCharmTileLabel(tileData);

      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'product-builder__charm-tile';
      tile.dataset.variantId = tileData.id;
      tile.disabled = !isAvailable || atMax || atStockCap;

      if (!hasPreview) {
        tile.classList.add('is-unavailable');
      }
      if (selectedCount > 0) {
        tile.classList.add('is-selected');
      }

      var media = document.createElement('span');
      media.className = 'product-builder__charm-tile-media';

      if (tileData.preview_image) {
        var img = configureBuilderImage(document.createElement('img'));
        img.src = self.resolveCharmPreviewImageUrl(tileData.preview_image);
        img.alt = tileLabel;
        media.appendChild(img);
      } else {
        var letter = document.createElement('span');
        letter.className = 'product-builder__charm-tile-letter';
        letter.textContent = tileLabel;
        media.appendChild(letter);
      }

      if (selectedCount > 0) {
        var badge = document.createElement('span');
        badge.className = 'product-builder__charm-count';
        badge.textContent = String(selectedCount);
        media.appendChild(badge);
      }

      tile.appendChild(media);

      var label = document.createElement('span');
      label.className = 'product-builder__charm-tile-label';
      label.textContent = tileLabel;
      tile.appendChild(label);

      tile.addEventListener('click', function () {
        self.onCharmTileClick(tileData);
      });

      if (self.supportsHover) {
        tile.addEventListener('mouseenter', function (e) {
          if (!isAvailable) return;
          if (self.isNextCharmComplementary()) return;
          self.showPriceTooltip(e.currentTarget, tileData.price);
        });
        tile.addEventListener('mouseleave', function () {
          self.hidePriceTooltip();
        });
      }

      grid.appendChild(tile);
    });
  };

  /* ==========================================================================
     CHARM SELECTOR INPUT (experimental)
     Enable with ?charm_selector=input
     Remove this block + overlay markup + CSS to drop the test feature.
     ========================================================================== */
  ProductBuilder.CHARM_SELECTOR_INPUT_DELAY = 1500;

  ProductBuilder.prototype.isCharmSelectorInputEnabled = function () {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get('charm_selector') !== 'input') return false;
    } catch (err) {
      return false;
    }

    if (this.hasSlotGroups()) return false;
    if (!this.charmTiles.length) return true;

    return this.charmTiles.some(function (tile) {
      return (tile.type || 'letter') === 'letter';
    });
  };

  ProductBuilder.prototype.getCharmSelectorMaxLength = function () {
    var max = this.getPoolMax();
    return max > 0 ? max : 5;
  };

  ProductBuilder.prototype.sanitizeCharmSelectorValue = function (value) {
    var max = this.getCharmSelectorMaxLength();
    return String(value || '')
      .toUpperCase()
      .replace(/[^A-Z]/g, '')
      .slice(0, max);
  };

  ProductBuilder.prototype.getCharmSelectorLetterKey = function (charmOrTile) {
    var label = this.getCharmTileLabel(charmOrTile);
    var match = String(label || '').toUpperCase().match(/[A-Z]/);
    return match ? match[0] : '';
  };

  ProductBuilder.prototype.findCharmTileByLetter = function (letter) {
    var key = String(letter || '').toUpperCase();
    if (!key) return null;

    for (var i = 0; i < this.charmTiles.length; i++) {
      var tile = this.charmTiles[i];
      if ((tile.type || 'letter') !== 'letter') continue;
      if (this.getCharmSelectorLetterKey(tile) === key) {
        return tile;
      }
    }

    return null;
  };

  ProductBuilder.prototype.syncCharmSelectorInputUI = function () {
    if (!this.root || !this.els.charmSelector) return;

    var enabled = this.isCharmSelectorInputEnabled();
    this.root.classList.toggle('product-builder--charm-selector-input', enabled);
    this.els.charmSelector.hidden = !enabled;

    if (!enabled) return;

    var max = this.getCharmSelectorMaxLength();
    if (this.els.charmSelectorMax) {
      this.els.charmSelectorMax.textContent = String(max);
    }
    if (this.els.charmSelectorInput) {
      this.els.charmSelectorInput.maxLength = max;
    }
  };

  ProductBuilder.prototype.getCharmSelectorValueFromSelection = function () {
    var self = this;
    return this.getSelectedCharmsList().map(function (charm) {
      return self.getCharmSelectorLetterKey(charm);
    }).join('');
  };

  ProductBuilder.prototype.syncCharmSelectorInputFromSelection = function () {
    if (!this.isCharmSelectorInputEnabled() || !this.els.charmSelectorInput) return;
    if (this.charmSelectorInputTimer) return;

    var nextValue = this.getCharmSelectorValueFromSelection();
    if (this.els.charmSelectorInput.value !== nextValue) {
      this.els.charmSelectorInput.value = nextValue;
    }
  };

  ProductBuilder.prototype.cancelCharmSelectorInputTimer = function () {
    if (this.charmSelectorInputTimer) {
      clearTimeout(this.charmSelectorInputTimer);
      this.charmSelectorInputTimer = null;
    }
  };

  ProductBuilder.prototype.scheduleCharmSelectorPreview = function () {
    var self = this;
    this.cancelCharmSelectorInputTimer();
    this.charmSelectorInputTimer = setTimeout(function () {
      self.charmSelectorInputTimer = null;
      self.applyCharmSelectorInput();
    }, ProductBuilder.CHARM_SELECTOR_INPUT_DELAY);
  };

  ProductBuilder.prototype.flushCharmSelectorInput = function () {
    if (!this.isCharmSelectorInputEnabled()) return;
    this.cancelCharmSelectorInputTimer();
    this.applyCharmSelectorInput();
  };

  ProductBuilder.prototype.canUseCharmTileForSelector = function (tileData, proposedCharms) {
    if (!tileData || !this.isVariantPurchasable(tileData) || !tileData.preview_image) return false;
    if (proposedCharms.length >= this.getPoolMax()) return false;

    var selectedCount = countCharmsForVariant(proposedCharms, tileData.id);
    var stockCap = this.getVariantStockCap(tileData);
    if (stockCap !== null && selectedCount >= stockCap) return false;

    return true;
  };

  ProductBuilder.prototype.applyCharmSelectorInput = function () {
    if (!this.isCharmSelectorInputEnabled() || !this.els.charmSelectorInput) return;

    var value = this.sanitizeCharmSelectorValue(this.els.charmSelectorInput.value);
    if (this.els.charmSelectorInput.value !== value) {
      this.els.charmSelectorInput.value = value;
    }

    var current = this.getSelectedCharmsList();
    var next = [];
    var skipped = false;

    for (var i = 0; i < value.length; i++) {
      var letter = value.charAt(i);
      var existing = current[i];
      if (
        existing &&
        this.getCharmSelectorLetterKey(existing) === letter &&
        this.getCharmVariant(existing.id)
      ) {
        next.push(existing);
        continue;
      }

      var tile = this.findCharmTileByLetter(letter);
      if (!tile || !this.canUseCharmTileForSelector(tile, next)) {
        skipped = true;
        continue;
      }

      next.push(this.buildCharmDataFromTile(tile));
    }

    var changed = next.length !== current.length;
    if (!changed) {
      for (var j = 0; j < next.length; j++) {
        if (next[j] !== current[j]) {
          changed = true;
          break;
        }
      }
    }

    if (changed) {
      this.selectedCharms = next;
      this.renderPreview();
      this.updateEditButtonVisibility();
      if (this.getSelectedCharmCount() >= this.getMinCharms()) {
        this.clearCharmValidation();
      }
    }

    if (skipped) {
      this.showCharmValidation('Some letters could not be added. Please try a different combination.');
    } else if (this.getSelectedCharmCount() >= this.getMinCharms()) {
      this.clearCharmValidation();
    }
  };

  ProductBuilder.prototype.bindCharmSelectorInput = function () {
    var self = this;
    var input = this.els.charmSelectorInput;
    if (!input || input.dataset.builderCharmSelectorBound === 'true') return;

    input.dataset.builderCharmSelectorBound = 'true';
    input.addEventListener('input', function () {
      var sanitized = self.sanitizeCharmSelectorValue(input.value);
      if (input.value !== sanitized) {
        input.value = sanitized;
      }
      self.scheduleCharmSelectorPreview();
    });

    input.addEventListener('blur', function () {
      self.flushCharmSelectorInput();
    });

    input.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
        self.flushCharmSelectorInput();
      }
    });
  };
  /* ===== end CHARM SELECTOR INPUT (experimental) ===== */

  ProductBuilder.prototype.showPriceTooltip = function (target, priceCents) {
    if (!this.els.priceTooltip) return;
    var rect = target.getBoundingClientRect();
    this.els.priceTooltip.textContent = '+' + formatMoney(priceCents, this.data.money_format);
    this.els.priceTooltip.hidden = false;
    this.els.priceTooltip.style.left = rect.left + rect.width / 2 + 'px';
    this.els.priceTooltip.style.top = rect.top + 'px';
  };

  ProductBuilder.prototype.hidePriceTooltip = function () {
    if (this.els.priceTooltip) {
      this.els.priceTooltip.hidden = true;
    }
  };

  ProductBuilder.prototype.onCharmTileClick = function (tileData) {
    var liveTile = this.getCharmVariant(tileData.id) || tileData;
    if (!this.canAddCharmVariant(liveTile)) {
      var groupMsg = this.getGroupLimitMessage();
      if (groupMsg && this.getSelectedCharmCount() < this.getPoolMax()) {
        this.showCharmValidation(groupMsg);
      }
      return;
    }

    if (this.getCharmEngravingConfig(liveTile)) {
      this.openCharmEngravingPanel(liveTile);
      return;
    }

    this.addCharmToSelection(this.buildCharmDataFromTile(liveTile));
  };

  ProductBuilder.prototype.resetBuilderSelection = function () {
    this.cancelCharmSelectorInputTimer();
    this.selectedCharms = this.hasSlotGroups() ? this.createEmptySlotStorage() : [];
    this.builderId = null;
    this.previewCharmStates = {};
    this.renderSelectedCharmsTray();
    this.renderCharmGrid();
    this.renderPreview();
    this.updateEditButtonVisibility();
    this.clearCharmValidation();
    this.syncCharmSelectorInputFromSelection();
  };

  ProductBuilder.prototype.startOver = function () {
    this.resetBuilderSelection();
    this.setStep('choose');
  };

  ProductBuilder.prototype.getMinCharms = function () {
    return this.getPoolMin();
  };

  ProductBuilder.prototype.getCharmValidationMessage = function () {
    var min = this.getMinCharms();
    if (this.getSelectedCharmCount() >= min) return '';
    return 'Please select at least ' + min + ' charm' + (min > 1 ? 's' : '') + '.';
  };

  ProductBuilder.prototype.showCharmValidation = function (message) {
    if (!this.els.charmValidation) return;
    if (message) {
      this.els.charmValidation.textContent = message;
      this.els.charmValidation.hidden = false;
    } else {
      this.els.charmValidation.hidden = true;
      this.els.charmValidation.textContent = '';
    }
  };

  ProductBuilder.prototype.clearCharmValidation = function () {
    this.showCharmValidation('');
  };

  ProductBuilder.prototype.validateMinCharms = function () {
    var message = this.getCharmValidationMessage();
    if (message) {
      this.showCharmValidation(message);
      return false;
    }
    this.clearCharmValidation();
    return true;
  };

  ProductBuilder.prototype.openEditDrawer = function () {
    if (!this.getSelectedCharmCount()) return;
    this.renderSelectedCharmsTray();
    this.setStep('edit');
  };

  ProductBuilder.prototype.updateCharmCounter = function () {
    var count = this.getSelectedCharmCount();
    var max = this.charmGroup ? (this.charmGroup.max || 5) : 5;

    if (this.els.charmCounterText) {
      this.els.charmCounterText.textContent = count + ' / ' + max;
    }

    if (this.els.editBtn) {
      this.els.editBtn.setAttribute(
        'aria-label',
        count === 0
          ? count + ' of ' + max + ' charms selected'
          : 'Edit or move ' + count + ' of ' + max + ' selected charms'
      );
    }
  };

  ProductBuilder.prototype.animateEditButtonIn = function () {
    var btn = this.els.editBtn;
    if (!btn || btn.hidden || btn.classList.contains('is-faded')) return;

    btn.classList.remove('is-entering');
    void btn.offsetWidth;
    btn.classList.add('is-entering');
  };

  ProductBuilder.prototype.updateEditButtonVisibility = function () {
    var hasCharms = this.getSelectedCharmCount() > 0;
    var isEdit = this.step === 'edit';
    var isReview = this.step === 'review';

    if (this.els.editBtn) {
      var shouldShow = hasCharms && !isReview;
      var wasHidden = this.els.editBtn.hidden;

      this.els.editBtn.hidden = !shouldShow;
      this.els.editBtn.classList.toggle('is-faded', hasCharms && isEdit);

      if (shouldShow && !isEdit && wasHidden) {
        this.animateEditButtonIn();
      }
    }

    this.updateCharmCounter();
    this.updateRunningTotal();
    this.updateComplementaryNote();
    this.updateBespokeCharmsNote();
    this.updateReviewButtonState();
  };

  ProductBuilder.prototype.shouldDisableReviewButton = function () {
    var min = this.getMinCharms();
    if (min <= 0) return false;
    return this.getSelectedCharmCount() < min;
  };

  ProductBuilder.prototype.updateReviewButtonState = function () {
    if (!this.els.reviewBtn) return;

    var shouldDisable = this.shouldDisableReviewButton();
    this.els.reviewBtn.disabled = shouldDisable;

    if (shouldDisable) {
      this.els.reviewBtn.setAttribute('aria-disabled', 'true');
    } else {
      this.els.reviewBtn.removeAttribute('aria-disabled');
    }
  };

  ProductBuilder.prototype.updateComplementaryNote = function () {
    if (!this.els.complementaryNote) return;

    var count = this.getComplementaryCharmCount();
    if (count <= 0) {
      this.els.complementaryNote.hidden = true;
      this.els.complementaryNote.textContent = '';
      return;
    }

    var message = count === 1
      ? 'Your first charm is complimentary.'
      : 'Your first ' + count + ' charms are complimentary.';

    this.els.complementaryNote.textContent = message;
    this.els.complementaryNote.hidden = this.step === 'review';
  };

  ProductBuilder.prototype.updateRunningTotal = function () {
    if (!this.els.runningTotalValue) return;
    this.els.runningTotalValue.textContent = formatMoney(
      this.getTotalPrice(),
      this.data.money_format
    );
  };

  // Slot positions tuned per count — calibrate 1-by-1 against live preview.
  ProductBuilder.SLOT_PRESETS = {
    1: [{ x: 49, y: 73.2, rotation: 0 }],
    2: [
      { x: 40, y: 70.4, rotation: 11 },
      { x: 60.5, y: 71, rotation: -15 }
    ],
    3: [
      { x: 28, y: 51.1, rotation: 60 },
      { x: 49, y: 73.2, rotation: 0 },
      { x: 72.4, y: 50, rotation: 300 }
    ],
    4: [
      { x: 32.5, y: 37.8, rotation: 116 },
      { x: 33, y: 65, rotation: 38 },
      { x: 67.3, y: 66, rotation: -47 },
      { x: 69, y: 38.4, rotation: -116 }
    ],
    5: [
      { x: 34.3, y: 35, rotation: 136 },
      { x: 29.6, y: 60, rotation: 48 },
      { x: 49, y: 73.2, rotation: 0 },
      { x: 71.6, y: 55.7, rotation: 299 },
      { x: 67.8, y: 36.4, rotation: 230 }
    ]
  };

  ProductBuilder.prototype.getPlacementMode = function () {
    var mode = this.getActivePlacement().mode || 'slots';
    if (mode === 'along_chain' || mode === 'along_circle') {
      mode = 'slots';
    }
    return mode;
  };

  ProductBuilder.prototype.getSlotGroups = function () {
    var groups = this.placement.slot_groups;
    return groups && groups.length ? groups : [];
  };

  ProductBuilder.prototype.hasSlotGroups = function () {
    return this.getSlotGroups().length > 0;
  };

  ProductBuilder.prototype.getSlotGroupById = function (groupId) {
    var groups = this.getSlotGroups();
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].id === groupId) {
        return groups[i];
      }
    }
    return null;
  };

  ProductBuilder.prototype.getSelectedCharmCount = function () {
    if (!this.hasSlotGroups()) {
      return this.selectedCharms.length;
    }

    var count = 0;
    for (var i = 0; i < this.selectedCharms.length; i++) {
      if (this.selectedCharms[i]) count++;
    }
    return count;
  };

  ProductBuilder.prototype.getSelectedCharmsList = function () {
    if (!this.hasSlotGroups()) {
      return this.selectedCharms.slice();
    }

    var list = [];
    var indices = this.getGlobalAddOrder();

    for (var i = 0; i < indices.length; i++) {
      var charm = this.getCharmAtSlot(indices[i]);
      if (charm) list.push(charm);
    }

    return list;
  };

  ProductBuilder.prototype.getCharmAtSlot = function (slotIndex) {
    return this.selectedCharms[slotIndex] || null;
  };

  ProductBuilder.prototype.createEmptySlotStorage = function () {
    var size = this.getPoolMax();
    var arr = new Array(size);

    for (var i = 0; i < size; i++) {
      arr[i] = null;
    }

    return arr;
  };

  ProductBuilder.prototype.ensureSlotStorage = function () {
    if (!this.hasSlotGroups()) return;

    var size = this.getPoolMax();

    if (!Array.isArray(this.selectedCharms)) {
      this.selectedCharms = this.createEmptySlotStorage();
      return;
    }

    while (this.selectedCharms.length < size) {
      this.selectedCharms.push(null);
    }
  };

  ProductBuilder.prototype.getAllSlotIndices = function () {
    var indices = [];
    var groups = this.getSlotGroups();

    groups.forEach(function (group) {
      (group.slots || []).forEach(function (slotIndex) {
        if (indices.indexOf(slotIndex) === -1) {
          indices.push(slotIndex);
        }
      });
    });

    indices.sort(function (a, b) {
      return a - b;
    });

    return indices;
  };

  ProductBuilder.prototype.getAllSlotPositions = function () {
    return this.getCharmSlots(this.getPoolMax());
  };

  ProductBuilder.prototype.getOccupiedSlotsInGroup = function (group) {
    return this.getSlotFillOrder(group).filter(function (slotIndex) {
      return this.getCharmAtSlot(slotIndex);
    }, this);
  };

  ProductBuilder.prototype.getGlobalAddOrder = function () {
    var placement = this.placement || {};

    if (placement.add_order && placement.add_order.length) {
      return placement.add_order.map(function (slotIndex) {
        return Number(slotIndex);
      });
    }

    var groups = this.getSlotGroups();
    if (!groups.length) return [];

    var startIndex = 0;
    var startId = placement.alternate_from || placement.first_hoop;

    if (startId) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].id === startId) {
          startIndex = i;
          break;
        }
      }
    } else if (groups.length === 2) {
      startIndex = 1;
    }

    var groupOrders = groups.map(function (group) {
      return this.getSlotFillOrder(group);
    }, this);

    var maxRounds = 0;
    groupOrders.forEach(function (order) {
      if (order.length > maxRounds) maxRounds = order.length;
    });

    var sequence = [];
    for (var round = 0; round < maxRounds; round++) {
      for (var g = 0; g < groups.length; g++) {
        var order = groupOrders[(startIndex + g) % groups.length];
        if (round < order.length) {
          sequence.push(order[round]);
        }
      }
    }

    return sequence;
  };

  ProductBuilder.prototype.parseSlotSets = function (slotSets) {
    if (!slotSets) return null;

    if (typeof slotSets === 'string') {
      try {
        slotSets = JSON.parse(slotSets);
      } catch (e) {
        return null;
      }
    }

    return slotSets && typeof slotSets === 'object' ? slotSets : null;
  };

  ProductBuilder.prototype.getSlotSetEntry = function (slotSets, count) {
    var sets = this.parseSlotSets(slotSets);
    if (!sets) return null;

    var key = String(count);
    if (sets[key]) return sets[key];
    if (sets[count]) return sets[count];
    return null;
  };

  ProductBuilder.prototype.normalizePlacementConfig = function () {
    var placement = this.placement;
    if (!placement || !placement.slot_groups || !placement.slot_groups.length) return;

    var topSets = this.parseSlotSets(placement.slot_sets);
    if (topSets) {
      placement.slot_sets = topSets;
    }

    placement.slot_groups.forEach(function (group, groupIndex) {
      var groupSets = this.parseSlotSets(group.slot_sets);
      if (groupSets) {
        group.slot_sets = groupSets;
        return;
      }

      if (!topSets) return;

      if (groupIndex === 0) {
        group.slot_sets = {
          1: this.getSlotSetEntry(topSets, 1),
          2: this.getSlotSetEntry(topSets, 2)
        };
        return;
      }

      if (groupIndex === 1) {
        var three = this.getSlotSetEntry(topSets, 3) || [];
        var four = this.getSlotSetEntry(topSets, 4) || [];
        group.slot_sets = {
          1: three.length ? [three[three.length - 1]] : null,
          2: four.length >= 2 ? four.slice(-2) : null
        };
      }
    }, this);
  };

  ProductBuilder.prototype.getLegacyGroupSlotPositions = function (groupIndex, count) {
    var topSets = this.parseSlotSets(this.placement.slot_sets);
    if (!topSets) return null;

    if (groupIndex === 0) {
      return this.getSlotSetEntry(topSets, count);
    }

    if (groupIndex === 1) {
      if (count === 1) {
        var three = this.getSlotSetEntry(topSets, 3) || [];
        return three.length ? [three[three.length - 1]] : null;
      }

      if (count === 2) {
        var four = this.getSlotSetEntry(topSets, 4) || [];
        return four.length >= 2 ? four.slice(-2) : null;
      }
    }

    return null;
  };

  ProductBuilder.prototype.getGroupSlotPositions = function (group, count) {
    var self = this;
    var normalize = function (slot) {
      return self.normalizeSlot(slot, self.placement);
    };
    var groupSet = this.getSlotSetEntry(group.slot_sets, count);

    if (groupSet && groupSet.length) {
      return groupSet.map(normalize);
    }

    var groups = this.getSlotGroups();
    var groupIndex = groups.indexOf(group);
    var legacySet = this.getLegacyGroupSlotPositions(groupIndex, count);

    if (legacySet && legacySet.length) {
      return legacySet.map(normalize);
    }

    console.warn(
      '[ProductBuilder] Missing slot_sets for group',
      group.id,
      'with',
      count,
      'charm(s). Check custom.builder_config placement.slot_groups[].slot_sets.'
    );

    return [];
  };

  ProductBuilder.prototype.getPreviewSlotForIndex = function (slotIndex) {
    if (!this.hasSlotGroups()) {
      return null;
    }

    var group = this.getSlotGroupForIndex(slotIndex);
    if (!group || !this.getCharmAtSlot(slotIndex)) {
      return null;
    }

    var groupCount = this.countCharmsInGroup(group);
    var occupiedSlots = this.getOccupiedSlotsInGroup(group);
    var positionInGroup = occupiedSlots.indexOf(slotIndex);

    if (positionInGroup === -1) {
      return null;
    }

    var positions = this.getGroupSlotPositions(group, groupCount);
    return positions[positionInGroup] || null;
  };

  ProductBuilder.prototype.forEachSelectedCharm = function (callback, thisArg) {
    var context = thisArg || this;

    if (!this.hasSlotGroups()) {
      this.selectedCharms.forEach(function (charm, index) {
        if (!charm) return;
        callback.call(context, charm, index, index);
      });
      return;
    }

    var sequence = 0;
    var indices = this.getGlobalAddOrder();

    for (var i = 0; i < indices.length; i++) {
      var slotIndex = indices[i];
      var charm = this.getCharmAtSlot(slotIndex);
      if (!charm) continue;
      callback.call(context, charm, slotIndex, sequence);
      sequence++;
    }
  };

  ProductBuilder.prototype.getSlotGroupForIndex = function (index) {
    var groups = this.getSlotGroups();
    for (var i = 0; i < groups.length; i++) {
      var slots = groups[i].slots || [];
      if (slots.indexOf(index) !== -1) {
        return groups[i];
      }
    }
    return null;
  };

  ProductBuilder.prototype.countCharmsInGroup = function (group) {
    if (!group) return 0;
    var slots = group.slots || [];
    var count = 0;

    for (var i = 0; i < slots.length; i++) {
      if (this.getCharmAtSlot(slots[i])) {
        count++;
      }
    }

    return count;
  };

  ProductBuilder.prototype.getPreferredAddGroupIndex = function () {
    var placement = this.placement || {};
    var groups = this.getSlotGroups();
    var startId = placement.alternate_from || placement.first_hoop;
    var startIndex = 1;

    if (startId) {
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].id === startId) {
          startIndex = i;
          break;
        }
      }
    } else if (groups.length === 2) {
      startIndex = 1;
    } else {
      startIndex = 0;
    }

    return this.getSelectedCharmCount() % 2 === 0 ? startIndex : (startIndex === 0 ? 1 : 0);
  };

  ProductBuilder.prototype.getSlotFillOrder = function (group) {
    if (group.add_order && group.add_order.length) {
      return group.add_order.slice();
    }

    var slots = (group.slots || []).slice().sort(function (a, b) {
      return a - b;
    });
    var groups = this.getSlotGroups();
    var groupIndex = groups.indexOf(group);

    if (groups.length === 2 && slots.length === 2 && groupIndex === 0) {
      return [slots[1], slots[0]];
    }

    return slots;
  };

  ProductBuilder.prototype.getFirstEmptySlotInGroup = function (group) {
    var slots = this.getSlotFillOrder(group);

    for (var i = 0; i < slots.length; i++) {
      if (!this.getCharmAtSlot(slots[i])) {
        return slots[i];
      }
    }

    return -1;
  };

  ProductBuilder.prototype.getGroupMax = function (group) {
    if (!group) return 0;
    if (group.max != null) return group.max;
    return (group.slots || []).length;
  };

  ProductBuilder.prototype.getNextAddIndex = function () {
    if (!this.hasSlotGroups()) {
      return this.getSelectedCharmCount() >= this.getPoolMax()
        ? -1
        : this.selectedCharms.length;
    }

    if (this.getSelectedCharmCount() >= this.getPoolMax()) return -1;

    this.ensureSlotStorage();

    var order = this.getGlobalAddOrder();
    for (var i = 0; i < order.length; i++) {
      if (!this.getCharmAtSlot(order[i])) {
        return order[i];
      }
    }

    return -1;
  };

  ProductBuilder.prototype.getGroupLimitMessage = function () {
    if (!this.hasSlotGroups()) return '';

    if (this.getNextAddIndex() !== -1 || this.getSelectedCharmCount() >= this.getPoolMax()) {
      return '';
    }

    return 'All charm slots are full. Remove a charm to continue.';
  };

  ProductBuilder.prototype.resolveSlotDropTarget = function (fromSlot, toSlot) {
    if (fromSlot == null || toSlot == null) return toSlot;
    if (fromSlot === toSlot) return toSlot;

    this.ensureSlotStorage();

    if (!this.getCharmAtSlot(toSlot)) {
      return toSlot;
    }

    var fromGroup = this.getSlotGroupForIndex(fromSlot);
    var toGroup = this.getSlotGroupForIndex(toSlot);

    if (!fromGroup || !toGroup || fromGroup.id === toGroup.id) {
      return toSlot;
    }

    var emptySlot = this.getFirstEmptySlotInGroup(toGroup);
    if (emptySlot !== -1) {
      return emptySlot;
    }

    return toSlot;
  };

  ProductBuilder.prototype.moveCharmToSlot = function (fromSlot, toSlot) {
    if (fromSlot == null || toSlot == null || fromSlot === toSlot) return false;

    this.ensureSlotStorage();

    toSlot = this.resolveSlotDropTarget(fromSlot, toSlot);
    if (fromSlot === toSlot) return false;

    var charm = this.getCharmAtSlot(fromSlot);
    if (!charm) return false;

    var targetCharm = this.getCharmAtSlot(toSlot);
    this.selectedCharms[fromSlot] = targetCharm || null;
    this.selectedCharms[toSlot] = charm;
    return true;
  };

  ProductBuilder.prototype.wouldReorderViolateGroups = function (fromIndex, toIndex) {
    if (!this.hasSlotGroups()) return false;
    if (fromIndex == null || toIndex == null || fromIndex === toIndex) return false;

    toIndex = this.resolveSlotDropTarget(fromIndex, toIndex);
    if (fromIndex === toIndex) return false;

    var copy = this.selectedCharms.slice();
    var moved = copy[fromIndex];
    if (!moved) return false;

    copy[fromIndex] = copy[toIndex] || null;
    copy[toIndex] = moved;

    var groups = this.getSlotGroups();
    for (var g = 0; g < groups.length; g++) {
      var group = groups[g];
      var slots = group.slots || [];
      var max = this.getGroupMax(group);
      var count = 0;

      for (var s = 0; s < slots.length; s++) {
        if (copy[slots[s]]) {
          count++;
        }
      }

      if (count > max) {
        return true;
      }
    }

    return false;
  };

  ProductBuilder.prototype.updateEditHint = function () {
    if (!this.els.editHint) return;

    if (this.hasSlotGroups()) {
      this.els.editHint.textContent = 'Drag charms between hoops to reorder them';
      return;
    }

    this.els.editHint.textContent = 'Drag charms to reorder them';
  };

  ProductBuilder.prototype.getDefaultCharmSizePercent = function () {
    var placement = this.getActivePlacement() || {};
    return placement.charm_size_percent != null ? placement.charm_size_percent : 8;
  };

  ProductBuilder.prototype.getConfigCharmSizePercent = function (productHandle, groupId) {
    if (!productHandle) return null;

    var placement = this.placement || {};
    if (placement.charm_sizes && placement.charm_sizes[productHandle] != null) {
      return placement.charm_sizes[productHandle];
    }

    var groups = this.config.charms || this.charmGroups || [];
    for (var i = 0; i < groups.length; i++) {
      var group = groups[i];
      if (groupId && group.id && group.id !== groupId) continue;

      if (group.product_handle === productHandle && group.size_percent != null) {
        return group.size_percent;
      }

      if (!group.products || !group.products.length) continue;

      for (var j = 0; j < group.products.length; j++) {
        var entry = group.products[j];
        var handle = typeof entry === 'string' ? entry : entry.product_handle;
        if (handle !== productHandle) continue;
        if (typeof entry !== 'string' && entry.size_percent != null) {
          return entry.size_percent;
        }
        break;
      }
    }

    return null;
  };

  ProductBuilder.prototype.resolveCharmSizePercent = function (options) {
    options = options || {};
    var defaultSize = this.getDefaultCharmSizePercent();

    if (options.slot) {
      var slotSize = options.slot.size_percent != null
        ? options.slot.size_percent
        : options.slot.charm_size_percent;
      if (slotSize != null) return Number(slotSize);
    }

    if (options.size_percent != null) return Number(options.size_percent);

    if (options.charm && options.charm.size_percent != null) {
      return Number(options.charm.size_percent);
    }

    var handle = options.product_handle || (options.charm && options.charm.product_handle);
    var groupId = options.groupId || (options.charm && options.charm.groupId);
    var mapped = this.getConfigCharmSizePercent(handle, groupId);
    if (mapped != null) return Number(mapped);

    return defaultSize;
  };

  // Horizontal hoop anchoring: lets each letter align its hoop (not its image
  // centre) to the slot. Config lives at placement.hoop_anchors, e.g.
  //   "hoop_anchors": { "left": 30, "center": 50, "right": 70,
  //                     "by_letter": { "N": "left", "J": "right" } }
  // Values are the hoop's horizontal position within the image (0=left..100=right).
  // No config, or an unlisted letter, falls back to 50 (image centre) = current behaviour.
  ProductBuilder.prototype.getHoopAnchorConfig = function () {
    var placement = this.getActivePlacement() || {};
    return placement.hoop_anchors || null;
  };

  ProductBuilder.prototype.resolveCharmAnchorXPercent = function (charm) {
    var config = this.getHoopAnchorConfig();
    if (!config) return 50;

    var named = {
      left: config.left != null ? Number(config.left) : 30,
      center: config.center != null ? Number(config.center) : 50,
      right: config.right != null ? Number(config.right) : 70
    };

    var anchor = null;
    var key = charm && (charm.design_token || charm.letter);
    if (key != null && config.by_letter) {
      anchor = config.by_letter[key];
      if (anchor == null) anchor = config.by_letter[String(key).toUpperCase()];
    }
    if (anchor == null) anchor = config.default;
    if (anchor == null) return named.center;

    if (typeof anchor === 'number') return anchor;
    if (named[anchor] != null) return named[anchor];

    var numeric = Number(anchor);
    return isNaN(numeric) ? 50 : numeric;
  };

  ProductBuilder.prototype.normalizeSlot = function (slot, placement) {
    var x = slot.x_percent != null ? slot.x_percent : slot.x;
    var y = slot.y_percent != null ? slot.y_percent : slot.y;
    var rotation = slot.rotation;

    if (rotation == null) {
      rotation = 0;
    }

    var sizePercent = slot.size_percent != null ? slot.size_percent : slot.charm_size_percent;

    return {
      x: x,
      y: y,
      rotation: rotation,
      size_percent: sizePercent != null ? Number(sizePercent) : null
    };
  };

  ProductBuilder.prototype.getCharmSlots = function (count) {
    var placement = this.getActivePlacement();
    var self = this;
    var normalize = function (slot) {
      return self.normalizeSlot(slot, placement);
    };

    // Custom slots only when explicitly opted in — avoids stale metafield overrides.
    if (placement.custom_slots) {
      var customSet = this.getSlotSetEntry(placement.slot_sets, count);
      if (customSet && customSet.length) {
        return customSet.map(normalize);
      }
      if (placement.slots && placement.slots[count]) {
        return placement.slots[count].map(normalize);
      }
      if (this.hasSlotGroups()) {
        return [];
      }
    }

    if (ProductBuilder.SLOT_PRESETS[count]) {
      return ProductBuilder.SLOT_PRESETS[count].map(normalize);
    }

    if (ProductBuilder.SLOT_PRESETS[5]) {
      return ProductBuilder.SLOT_PRESETS[5].slice(0, count).map(normalize);
    }

    return [];
  };

  ProductBuilder.prototype.getCharmAnimationMode = function () {
    var placement = this.placement || {};
    var animation = placement.charm_animation;

    if (animation === 'slide' || animation === 'cord') return 'slide';
    if (this.usesHangCharmAnimation()) return 'hang';

    return 'none';
  };

  ProductBuilder.prototype.usesCharmAnimation = function () {
    return this.getCharmAnimationMode() !== 'none';
  };

  ProductBuilder.prototype.usesHangCharmAnimation = function () {
    var placement = this.placement || {};

    if (placement.charm_animation === 'slide' || placement.charm_animation === 'cord') return false;
    if (placement.hang_animation === false) return false;
    if (placement.hang_animation === true || placement.charm_animation === 'hang') return true;

    // Backward compatible: grouped layouts keep hang animation unless disabled.
    return this.hasSlotGroups();
  };

  ProductBuilder.prototype.getCharmSlideFromX = function (slot, animation, charm) {
    if (animation === 'settle') {
      var prev = charm && charm.instanceId ? this.previewCharmStates[charm.instanceId] : null;
      if (prev && prev.x != null && slot && slot.x != null) {
        var delta = Number(slot.x) - Number(prev.x);
        if (Math.abs(delta) > 0.01) {
          return (delta > 0 ? -2.5 : 2.5) + '%';
        }
      }
      return '0%';
    }

    var x = slot && slot.x != null ? Number(slot.x) : 50;
    if (x > 50.05) return '-3.5%';
    if (x < 49.95) return '3.5%';
    return '2.5%';
  };

  ProductBuilder.prototype.getPreviewCharmAnimation = function (charm, slotIndex, slot) {
    if (!charm || !charm.instanceId) return 'none';

    var prev = this.previewCharmStates[charm.instanceId];
    if (!prev) return 'enter';
    if (prev.slotIndex !== slotIndex) return 'enter';

    if (slot && (
      prev.x !== slot.x ||
      prev.y !== slot.y ||
      prev.rotation !== slot.rotation
    )) {
      return 'settle';
    }

    return 'none';
  };

  ProductBuilder.prototype.syncPreviewCharmState = function (charm, slotIndex, slot) {
    if (!charm || !charm.instanceId) return;

    this.previewCharmStates[charm.instanceId] = {
      slotIndex: slotIndex,
      x: slot ? slot.x : null,
      y: slot ? slot.y : null,
      rotation: slot ? slot.rotation : null
    };
  };

  ProductBuilder.prototype.prunePreviewCharmStates = function () {
    var active = {};

    this.forEachSelectedCharm(function (charm, slotIndex) {
      if (charm.instanceId) {
        active[charm.instanceId] = true;
      }
    });

    for (var id in this.previewCharmStates) {
      if (!active[id]) {
        delete this.previewCharmStates[id];
      }
    }
  };

  ProductBuilder.prototype.appendPreviewCharm = function (layer, charm, slot, slotIndex) {
    var mode = this.getCharmAnimationMode();
    var charmSizePercent = this.resolveCharmSizePercent({
      charm: charm,
      slot: slot
    });
    var motion = mode !== 'none' ? this.getPreviewCharmAnimation(charm, slotIndex, slot) : 'none';

    var img = configureBuilderImage(document.createElement('img'));
    img.src = this.resolveCharmPreviewImageUrl(charm.preview_image);
    img.alt = charm.letter;
    img.style.left = slot.x + '%';
    img.style.top = slot.y + '%';
    img.style.width = charmSizePercent + '%';

    var anchorXPercent = this.resolveCharmAnchorXPercent(charm);
    if (anchorXPercent !== 50) {
      img.style.setProperty('--charm-anchor-x', -anchorXPercent + '%');
    }

    if (mode === 'hang') {
      img.className = 'product-builder__charm-on-canvas product-builder__charm-on-canvas--hang';
      img.style.setProperty('--charm-rotate', slot.rotation + 'deg');
    } else if (mode === 'slide') {
      img.className = 'product-builder__charm-on-canvas product-builder__charm-on-canvas--slide';
      img.style.setProperty('--charm-rotate', slot.rotation + 'deg');
      if (motion === 'enter' || motion === 'settle') {
        img.style.setProperty('--charm-slide-from-x', this.getCharmSlideFromX(slot, motion, charm));
      }
    } else {
      img.className = 'product-builder__charm-on-canvas';
      img.style.transform = 'translate(' + -anchorXPercent + '%, 0) rotate(' + slot.rotation + 'deg)';
    }

    if (motion === 'enter') {
      img.classList.add('is-entering');
    } else if (motion === 'settle') {
      img.classList.add('is-settling');
    }

    layer.appendChild(img);

    if (mode !== 'none') {
      this.syncPreviewCharmState(charm, slotIndex, slot);
    }
  };

  ProductBuilder.prototype.appendGroupedPreviewCharm = function (layer, charm, slot, slotIndex) {
    this.appendPreviewCharm(layer, charm, slot, slotIndex);
  };

  ProductBuilder.prototype.renderPreviewSlots = function (layer, placement) {
    var self = this;

    if (this.hasSlotGroups()) {
      var slotIndices = this.getGlobalAddOrder();
      var sequence = 0;

      slotIndices.forEach(function (slotIndex) {
        var charm = self.getCharmAtSlot(slotIndex);
        if (!charm) return;

        var slot = self.getPreviewSlotForIndex(slotIndex);
        if (!slot) return;

        self.appendPreviewCharm(layer, charm, slot, slotIndex);
        sequence++;
      });

      if (this.usesCharmAnimation()) {
        this.prunePreviewCharmStates();
      }
      return;
    }

    var slots = this.getCharmSlots(this.selectedCharms.length);

    this.selectedCharms.forEach(function (charm, index) {
      var slot = slots[index];
      if (!slot) return;

      self.appendPreviewCharm(layer, charm, slot, index);
    });

    if (this.usesCharmAnimation()) {
      this.prunePreviewCharmStates();
    }
  };

  ProductBuilder.prototype.renderPreviewLine = function (layer, placement) {
    var self = this;
    var charms = this.getSelectedCharmsList();
    var count = charms.length;
    var spacingPercent = placement.spacing_percent || 4.5;
    var offsetX = placement.offset_x_percent || 50;
    var offsetY = placement.offset_y_percent || 78;
    var sizes = charms.map(function (charm) {
      return self.resolveCharmSizePercent({ charm: charm });
    });
    var totalWidth = 0;

    for (var i = 0; i < count; i++) {
      totalWidth += sizes[i];
      if (i < count - 1) totalWidth += spacingPercent;
    }

    var cursorX = offsetX - totalWidth / 2;

    charms.forEach(function (charm, index) {
      var charmSizePercent = sizes[index];
      var img = configureBuilderImage(document.createElement('img'));
      img.src = self.resolveCharmPreviewImageUrl(charm.preview_image);
      img.alt = charm.letter;
      img.className = 'product-builder__charm-on-canvas';
      img.style.left = cursorX + charmSizePercent / 2 + '%';
      img.style.top = offsetY + '%';
      img.style.width = charmSizePercent + '%';
      img.style.transform = 'translate(-50%, -50%)';
      layer.appendChild(img);
      cursorX += charmSizePercent + spacingPercent;
    });
  };

  ProductBuilder.prototype.renderPreviewCharms = function () {
    var layer = this.els.charmsLayer;
    if (!layer) return;

    var charmAnimationMode = this.getCharmAnimationMode();
    layer.classList.toggle('product-builder__charms-layer--hang', charmAnimationMode === 'hang');
    layer.classList.toggle('product-builder__charms-layer--slide', charmAnimationMode === 'slide');
    layer.innerHTML = '';
    if (!this.getSelectedCharmCount()) {
      if (this.previewZoomOpen) this.syncPreviewZoomContent();
      return;
    }

    var canvas = this.root.querySelector('[data-builder-canvas]');
    if (!canvas) return;

    var placement = this.getActivePlacement();
    var mode = this.getPlacementMode();
    if (mode === 'slots') {
      this.renderPreviewSlots(layer, placement);
    } else if (mode === 'along_line') {
      this.renderPreviewLine(layer, placement);
    } else {
      this.renderPreviewSlots(layer, placement);
    }

    if (this.previewZoomOpen) {
      this.syncPreviewZoomContent();
    }
  };

  ProductBuilder.prototype.renderPreview = function () {
    var layer = this.els.charmsLayer;
    if (!layer) return;

    this.applyPreviewAppearance();

    var nextUrl = this.getBasePreviewImageUrl();
    var currentUrl = this.els.baseImage
      ? (this.els.baseImage.getAttribute('src') || this.els.baseImage.src || '')
      : '';
    var needsBaseSwap = this.usesBaseImagesByCount()
      && nextUrl
      && !this.samePreviewImageUrl(currentUrl, nextUrl);

    var self = this;
    var paint = function () {
      self.updateBasePreview();
      self.renderPreviewCharms();
    };

    // Wait for the next hoop/base image so the charm doesn't hang on the old chain.
    if (needsBaseSwap) {
      var token = ++this.previewRenderToken;
      this.preloadPreviewImage(nextUrl).then(function () {
        if (token !== self.previewRenderToken) return;
        paint();
      });
      return;
    }

    this.previewRenderToken += 1;
    paint();
  };

  ProductBuilder.prototype.ensureDropPlaceholder = function () {
    if (!this.dropPlaceholder) {
      this.dropPlaceholder = document.createElement('div');
      this.dropPlaceholder.className = 'product-builder__drop-placeholder';
      this.dropPlaceholder.setAttribute('aria-hidden', 'true');
    }
    return this.dropPlaceholder;
  };

  ProductBuilder.prototype.ensureDropEndPlaceholder = function () {
    if (!this.dropEndPlaceholder) {
      this.dropEndPlaceholder = document.createElement('div');
      this.dropEndPlaceholder.className = 'product-builder__drop-placeholder product-builder__drop-end-placeholder';
      this.dropEndPlaceholder.setAttribute('aria-hidden', 'true');
    }
    return this.dropEndPlaceholder;
  };

  ProductBuilder.prototype.hideDropEndPlaceholder = function () {
    if (!this.dropEndPlaceholder) return;

    this.dropEndPlaceholder.classList.remove('is-visible');
    if (this.dropEndPlaceholder.parentNode) {
      this.dropEndPlaceholder.parentNode.removeChild(this.dropEndPlaceholder);
    }
  };

  ProductBuilder.prototype.getDragItemBounds = function (rects) {
    var bounds = {
      left: Infinity,
      top: Infinity,
      right: -Infinity,
      bottom: -Infinity
    };

    rects.forEach(function (entry) {
      bounds.left = Math.min(bounds.left, entry.left);
      bounds.top = Math.min(bounds.top, entry.top);
      bounds.right = Math.max(bounds.right, entry.right);
      bounds.bottom = Math.max(bounds.bottom, entry.bottom);
    });

    return bounds;
  };

  ProductBuilder.prototype.getDragDropContainer = function () {
    return this.els.selectedCharms || null;
  };

  ProductBuilder.prototype.getDraggableCharmItems = function (container, draggingEl) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll('.product-builder__selected-charm:not(.is-empty-slot)')
    ).filter(function (el) {
      return el !== draggingEl;
    });
  };

  ProductBuilder.prototype.getSlotElementsForHitTest = function (container) {
    if (!container) return [];

    return Array.prototype.slice.call(
      container.querySelectorAll('.product-builder__slot-group-charms [data-index]')
    );
  };

  ProductBuilder.prototype.cacheDragItemRects = function () {
    var container = this.getDragDropContainer();
    if (!container) {
      this.dragItemRects = [];
      return;
    }

    var items = Array.prototype.slice.call(
      container.querySelectorAll('.product-builder__selected-charm:not(.is-empty-slot)')
    );

    this.dragItemRects = items.map(function (el) {
      var rect = el.getBoundingClientRect();
      return {
        index: Number(el.dataset.index),
        left: rect.left,
        top: rect.top,
        right: rect.right,
        bottom: rect.bottom,
        width: rect.width,
        height: rect.height,
        centerX: rect.left + rect.width / 2,
        centerY: rect.top + rect.height / 2
      };
    });
  };

  ProductBuilder.prototype.insertDragOriginPlaceholder = function (item) {
    var container = this.getDragDropContainer();
    if (!container || !item || this.hasSlotGroups()) return;

    var placeholder = this.ensureDropPlaceholder();
    placeholder.classList.add('is-visible', 'is-origin');
    container.insertBefore(placeholder, item);
  };

  ProductBuilder.prototype.getFlatCharmDropIndex = function (clientX, clientY) {
    var rects = this.dragItemRects || [];
    if (!rects.length) return 0;

    var fromIndex = this.dragFromIndex;
    var bounds = this.getDragItemBounds(rects);
    var padding = Math.max(20, rects[0].height * 0.6);

    if (
      clientX < bounds.left - padding ||
      clientX > bounds.right + padding ||
      clientY < bounds.top - padding ||
      clientY > bounds.bottom + padding
    ) {
      return fromIndex != null ? fromIndex : rects[0].index;
    }

    var i;
    for (i = 0; i < rects.length; i++) {
      var directHit = rects[i];
      if (
        clientX >= directHit.left &&
        clientX <= directHit.right &&
        clientY >= directHit.top &&
        clientY <= directHit.bottom
      ) {
        return clientX < directHit.centerX ? directHit.index : directHit.index + 1;
      }
    }

    var rowTolerance = Math.max(12, rects[0].height * 0.35);
    var rows = [];

    rects.forEach(function (entry) {
      var row = null;
      for (var ri = 0; ri < rows.length; ri++) {
        if (Math.abs(rows[ri].top - entry.top) <= rowTolerance) {
          row = rows[ri];
          break;
        }
      }

      if (!row) {
        row = { top: entry.top, bottom: entry.bottom, items: [] };
        rows.push(row);
      }

      row.top = Math.min(row.top, entry.top);
      row.bottom = Math.max(row.bottom, entry.bottom);
      row.items.push(entry);
    });

    rows.sort(function (a, b) {
      return a.top - b.top;
    });

    rows.forEach(function (row) {
      row.items.sort(function (a, b) {
        return a.left - b.left;
      });
    });

    if (clientY < rows[0].top) {
      return rows[0].items[0].index;
    }

    var lastRow = rows[rows.length - 1];
    if (clientY > lastRow.bottom) {
      return lastRow.items[lastRow.items.length - 1].index + 1;
    }

    for (var gap = 0; gap < rows.length - 1; gap++) {
      if (clientY > rows[gap].bottom && clientY < rows[gap + 1].top) {
        return rows[gap + 1].items[0].index;
      }
    }

    var targetRow = null;
    for (var t = 0; t < rows.length; t++) {
      if (clientY >= rows[t].top && clientY <= rows[t].bottom) {
        targetRow = rows[t];
        break;
      }
    }

    if (!targetRow) {
      var closestDist = Infinity;
      for (var n = 0; n < rows.length; n++) {
        var rowCenterY = (rows[n].top + rows[n].bottom) / 2;
        var dist = Math.abs(clientY - rowCenterY);
        if (dist < closestDist) {
          closestDist = dist;
          targetRow = rows[n];
        }
      }
    }

    if (!targetRow) return 0;

    for (var h = 0; h < targetRow.items.length; h++) {
      if (clientX < targetRow.items[h].centerX) {
        return targetRow.items[h].index;
      }
    }

    return targetRow.items[targetRow.items.length - 1].index + 1;
  };

  ProductBuilder.prototype.getCharmDropSlotIndex = function (clientX, clientY, draggingEl) {
    var fromSlot = Number(draggingEl.dataset.index);
    var container = this.getDragDropContainer();
    if (!container) return fromSlot;

    var slots = this.getSlotElementsForHitTest(container);
    var hitSlot = null;

    for (var i = 0; i < slots.length; i++) {
      var rect = slots[i].getBoundingClientRect();
      if (
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom
      ) {
        hitSlot = Number(slots[i].dataset.index);
        break;
      }
    }

    if (hitSlot == null) {
      var closestDist = Infinity;

      for (var j = 0; j < slots.length; j++) {
        var slotRect = slots[j].getBoundingClientRect();
        var centerX = slotRect.left + slotRect.width / 2;
        var centerY = slotRect.top + slotRect.height / 2;
        var dist = Math.pow(clientX - centerX, 2) + Math.pow(clientY - centerY, 2);

        if (dist < closestDist) {
          closestDist = dist;
          hitSlot = Number(slots[j].dataset.index);
        }
      }
    }

    if (hitSlot == null) return fromSlot;

    return this.resolveSlotDropTarget(fromSlot, hitSlot);
  };

  ProductBuilder.prototype.getCharmDropIndex = function (clientX, clientY, draggingEl) {
    var container = this.getDragDropContainer();
    if (!container) return 0;

    if (this.hasSlotGroups() && draggingEl) {
      return this.getCharmDropSlotIndex(clientX, clientY, draggingEl);
    }

    if (this.dragItemRects && this.dragItemRects.length) {
      return this.getFlatCharmDropIndex(clientX, clientY);
    }

    var items = this.getDraggableCharmItems(container, draggingEl);
    if (!items.length) return 0;

    for (var i = 0; i < items.length; i++) {
      var rect = items[i].getBoundingClientRect();
      if (
        clientX >= rect.left &&
        clientX <= rect.right &&
        clientY >= rect.top &&
        clientY <= rect.bottom
      ) {
        return clientX < rect.left + rect.width / 2
          ? Number(items[i].dataset.index)
          : Number(items[i].dataset.index) + 1;
      }
    }

    var lastIndex = Number(items[items.length - 1].dataset.index);
    return lastIndex + 1;
  };

  ProductBuilder.prototype.updateSlotGroupDropTarget = function (targetSlotIndex) {
    var container = this.els.selectedCharms;
    if (!container) return;

    if (this.dragInsertIndex === targetSlotIndex) {
      return;
    }

    container.querySelectorAll('.is-drop-target').forEach(function (el) {
      el.classList.remove('is-drop-target');
    });

    this.dragInsertIndex = targetSlotIndex;

    var targetEl = container.querySelector('[data-index="' + targetSlotIndex + '"]');
    if (targetEl) {
      targetEl.classList.add('is-drop-target');
    }
  };

  ProductBuilder.prototype.updateFlatDropTarget = function (targetSlotIndex) {
    var container = this.getDragDropContainer();
    if (!container) return;

    var fromIndex = this.dragFromIndex;

    this.hideDropEndPlaceholder();

    if (this.dragInsertIndex === targetSlotIndex) {
      return;
    }

    container.querySelectorAll('.is-drop-target').forEach(function (el) {
      el.classList.remove('is-drop-target');
    });

    this.dragInsertIndex = targetSlotIndex;

    if (fromIndex != null && (targetSlotIndex === fromIndex || targetSlotIndex === fromIndex + 1)) {
      return;
    }

    var items = this.getDraggableCharmItems(container, this.draggingEl);
    var targetEl = null;

    for (var i = 0; i < items.length; i++) {
      if (Number(items[i].dataset.index) === targetSlotIndex) {
        targetEl = items[i];
        break;
      }
    }

    if (targetEl) {
      targetEl.classList.add('is-drop-target');
      return;
    }

    if (items.length) {
      var lastIndex = Number(items[items.length - 1].dataset.index);
      if (targetSlotIndex > lastIndex) {
        var endPlaceholder = this.ensureDropEndPlaceholder();
        endPlaceholder.classList.add('is-visible');
        container.appendChild(endPlaceholder);
      }
    }
  };

  ProductBuilder.prototype.updateDropPlaceholder = function (targetSlotIndex) {
    if (this.draggingEl == null) return;

    if (this.hasSlotGroups()) {
      this.updateSlotGroupDropTarget(targetSlotIndex);
      return;
    }

    this.updateFlatDropTarget(targetSlotIndex);
  };

  ProductBuilder.prototype.clearCharmDragState = function () {
    var container = this.els.selectedCharms;
    if (container) {
      container.classList.remove('is-drag-active');
      container.querySelectorAll('.product-builder__selected-charm.is-dragging').forEach(function (el) {
        el.classList.remove('is-dragging', 'is-dragging-collapsed');
      });
      container.querySelectorAll('.product-builder__slot-group-charms.is-drag-active').forEach(function (el) {
        el.classList.remove('is-drag-active');
      });
      container.querySelectorAll('.is-drop-target').forEach(function (el) {
        el.classList.remove('is-drop-target');
      });
    }

    if (this.dropPlaceholder) {
      this.dropPlaceholder.classList.remove('is-visible', 'is-origin');
      if (this.dropPlaceholder.parentNode) {
        this.dropPlaceholder.parentNode.removeChild(this.dropPlaceholder);
      }
    }

    this.hideDropEndPlaceholder();

    if (this.dragCloneEl && this.dragCloneEl.parentNode) {
      this.dragCloneEl.parentNode.removeChild(this.dragCloneEl);
    }

    document.body.classList.remove('product-builder-dragging');

    this.dragFromIndex = null;
    this.dragInsertIndex = null;
    this.draggingEl = null;
    this.dragCloneEl = null;
    this.dragPointerId = null;
    this.dragActive = false;
    this.dragItemRects = null;
  };

  ProductBuilder.prototype.reorderSelectedCharm = function (fromIndex, toIndex) {
    if (fromIndex == null || toIndex == null) return false;

    if (this.hasSlotGroups()) {
      toIndex = this.resolveSlotDropTarget(fromIndex, toIndex);
      if (fromIndex === toIndex) return false;
      if (this.wouldReorderViolateGroups(fromIndex, toIndex)) {
        return false;
      }
      return this.moveCharmToSlot(fromIndex, toIndex);
    }

    if (fromIndex === toIndex) return false;

    var targetIndex = toIndex;
    if (targetIndex > fromIndex) {
      targetIndex--;
    }
    if (targetIndex === fromIndex) return false;

    var moved = this.selectedCharms.splice(fromIndex, 1)[0];
    this.selectedCharms.splice(targetIndex, 0, moved);
    return true;
  };

  ProductBuilder.CHARM_DRAG_THRESHOLD = 8;

  ProductBuilder.prototype.createDragClone = function (item) {
    var sourceImg = item.querySelector('img');
    var clone = document.createElement('div');
    clone.className = 'product-builder__drag-clone';

    if (sourceImg) {
      var cloneImg = configureBuilderImage(document.createElement('img'));
      cloneImg.src = sourceImg.src;
      cloneImg.alt = sourceImg.alt;
      clone.appendChild(cloneImg);
    }

    document.body.appendChild(clone);
    this.dragCloneEl = clone;
    return clone;
  };

  ProductBuilder.prototype.moveDragClone = function (clientX, clientY, offsetX, offsetY) {
    if (!this.dragCloneEl) return;
    this.dragCloneEl.style.left = (clientX - offsetX) + 'px';
    this.dragCloneEl.style.top = (clientY - offsetY) + 'px';
  };

  ProductBuilder.prototype.startCharmPointerReorder = function (item, event) {
    var self = this;
    var container = this.els.selectedCharms;
    if (!container || this.draggingEl) return;
    if (event.pointerType === 'mouse' && event.button !== 0) return;

    var startX = event.clientX;
    var startY = event.clientY;
    var rect = item.getBoundingClientRect();
    var offsetX = event.clientX - rect.left;
    var offsetY = event.clientY - rect.top;

    this.dragFromIndex = Number(item.dataset.index);
    this.dragPointerId = event.pointerId;
    this.dragActive = false;

    var onMove = function (e) {
      if (e.pointerId !== self.dragPointerId) return;

      if (!self.dragActive) {
        var dx = e.clientX - startX;
        var dy = e.clientY - startY;
        if (Math.sqrt(dx * dx + dy * dy) < ProductBuilder.CHARM_DRAG_THRESHOLD) return;

        self.dragActive = true;
        self.draggingEl = item;
        self.cacheDragItemRects();
        self.insertDragOriginPlaceholder(item);
        container.classList.add('is-drag-active');
        item.classList.add('is-dragging', 'is-dragging-collapsed');
        document.body.classList.add('product-builder-dragging');
        self.createDragClone(item);
        self.moveDragClone(e.clientX, e.clientY, offsetX, offsetY);
        self.updateDropPlaceholder(self.getCharmDropIndex(e.clientX, e.clientY, item));

        try {
          item.setPointerCapture(e.pointerId);
        } catch (err) {
          // Pointer capture may be unsupported in older browsers.
        }
      }

      if (e.cancelable) e.preventDefault();
      self.moveDragClone(e.clientX, e.clientY, offsetX, offsetY);
      self.updateDropPlaceholder(self.getCharmDropIndex(e.clientX, e.clientY, self.draggingEl));
    };

    var onEnd = function (e) {
      if (e.pointerId !== self.dragPointerId) return;

      document.removeEventListener('pointermove', onMove);
      document.removeEventListener('pointerup', onEnd);
      document.removeEventListener('pointercancel', onEnd);

      try {
        item.releasePointerCapture(e.pointerId);
      } catch (err) {
        // Ignore release failures after drag end.
      }

      var shouldReorder = self.dragActive;
      var fromIndex = self.dragFromIndex;
      var toIndex = self.dragInsertIndex;
      self.clearCharmDragState();

      if (shouldReorder && self.reorderSelectedCharm(fromIndex, toIndex)) {
        self.renderSelectedCharmsTray();
        self.renderPreview();
      }
    };

    document.addEventListener('pointermove', onMove, { passive: false });
    document.addEventListener('pointerup', onEnd);
    document.addEventListener('pointercancel', onEnd);
  };

  ProductBuilder.prototype.createSelectedCharmItem = function (charm, index) {
    var self = this;
    var item = document.createElement('div');
    item.className = 'product-builder__selected-charm';
    item.dataset.index = String(index);

    var img = configureBuilderImage(document.createElement('img'));
    img.src = this.resolveCharmPreviewImageUrl(charm.preview_image);
    img.alt = charm.letter;
    item.appendChild(img);

    var removeBtn = document.createElement('button');
    removeBtn.type = 'button';
    removeBtn.className = 'product-builder__selected-charm-remove';
    removeBtn.setAttribute('aria-label', 'Remove ' + charm.letter);
    removeBtn.textContent = '×';
    removeBtn.addEventListener('pointerdown', function (e) {
      e.stopPropagation();
    });
    removeBtn.addEventListener('click', function (e) {
      e.stopPropagation();
      if (self.hasSlotGroups()) {
        self.selectedCharms[index] = null;
      } else {
        self.selectedCharms.splice(index, 1);
      }
      self.renderSelectedCharmsTray();
      self.renderCharmGrid();
      self.renderPreview();
      if (self.getSelectedCharmCount() === 0 && self.step === 'edit') {
        self.setStep('choose');
      } else {
        self.updateEditButtonVisibility();
      }
    });
    item.appendChild(removeBtn);

    item.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.product-builder__selected-charm-remove')) return;
      self.startCharmPointerReorder(item, e);
    });

    return item;
  };

  ProductBuilder.prototype.createEmptySlotPlaceholder = function (slotIndex) {
    var placeholder = document.createElement('div');
    placeholder.className = 'product-builder__selected-charm is-empty-slot';
    placeholder.dataset.index = String(slotIndex);
    placeholder.setAttribute('aria-hidden', 'true');
    return placeholder;
  };

  ProductBuilder.prototype.renderSelectedCharmsTray = function () {
    var container = this.els.selectedCharms;
    if (!container) return;

    this.clearCharmDragState();
    this.updateEditHint();

    var self = this;
    container.innerHTML = '';
    container.classList.toggle('has-slot-groups', this.hasSlotGroups());

    if (!this.hasSlotGroups()) {
      this.selectedCharms.forEach(function (charm, index) {
        container.appendChild(self.createSelectedCharmItem(charm, index));
      });
      return;
    }

    this.getSlotGroups().forEach(function (group) {
      var groupWrap = document.createElement('div');
      groupWrap.className = 'product-builder__slot-group';
      groupWrap.dataset.slotGroup = group.id;

      var heading = document.createElement('p');
      heading.className = 'product-builder__slot-group-label';
      heading.textContent = group.label || group.id;
      groupWrap.appendChild(heading);

      var row = document.createElement('div');
      row.className = 'product-builder__slot-group-charms';

      self.getSlotFillOrder(group).forEach(function (slotIndex) {
        var charm = self.getCharmAtSlot(slotIndex);
        if (charm) {
          row.appendChild(self.createSelectedCharmItem(charm, slotIndex));
        } else {
          row.appendChild(self.createEmptySlotPlaceholder(slotIndex));
        }
      });

      groupWrap.appendChild(row);
      container.appendChild(groupWrap);
    });
  };

  ProductBuilder.prototype.renderReview = function () {
    var list = this.els.reviewList;
    if (!list) return;

    list.innerHTML = '';
    var base = this.getBaseVariant();

    if (base) {
      list.appendChild(this.createReviewItem({
        image: this.data.base.preview_image,
        title: this.data.base.title,
        subtitle: this.getBaseReviewSubtitle(),
        price: base.price,
        isBase: true
      }));
    }

    this.forEachSelectedCharm(function (charm, slotIndex, sequence) {
      list.appendChild(this.createReviewItem({
        image: charm.preview_image,
        title: charm.product_title || (this.charmGroup && this.charmGroup.product_title) || 'Charm',
        subtitle: this.getCharmReviewSubtitle(charm),
        slotLabel: this.hasSlotGroups() ? this.getSlotPlacementLabel(slotIndex) : '',
        price: charm.price,
        isComplementary: this.isComplementaryCharmIndex(sequence)
      }));
    }, this);

    this.getCartExtras().forEach(function (extra) {
      var quantity = this.getCartExtraQuantity(extra);
      var unitPrice = this.getCartExtraUnitPrice(extra);
      if (quantity < 1 || unitPrice <= 0) return;

      var label = extra.label || extra.role || 'Service charge';
      list.appendChild(this.createReviewItem({
        image: extra.preview_image || '',
        title: label,
        subtitle: quantity > 1 ? quantity + ' × ' + formatMoney(unitPrice, this.data.money_format) : '',
        price: unitPrice * quantity
      }));
    }, this);

    this.updateRunningTotal();
  };

  ProductBuilder.prototype.getBaseReviewSubtitle = function () {
    var base = this.getBaseVariant();
    if (!base) return '';

    var variants = (this.data.base && this.data.base.variants) || [];
    if (variants.length <= 1) return '';

    var title = (base.title || '').trim();
    if (!title || /^default\s+title$/i.test(title)) return '';

    return title;
  };

  ProductBuilder.prototype.createReviewItem = function (item) {
    var li = document.createElement('li');
    li.className = 'product-builder__review-item';
    if (item.isBase) {
      li.classList.add('is-base');
    }
    if (item.isComplementary) {
      li.classList.add('is-complementary');
    }

    var thumb = document.createElement('div');
    thumb.className = 'product-builder__review-item-thumb';

    if (item.image) {
      var img = configureBuilderImage(document.createElement('img'));
      img.src = item.image;
      img.alt = item.title;
      thumb.appendChild(img);
    }
    li.appendChild(thumb);

    var details = document.createElement('div');
    details.className = 'product-builder__review-item-details';

    var title = document.createElement('div');
    title.className = 'product-builder__review-item-title';
    title.textContent = item.title;

    details.appendChild(title);

    if (item.subtitle) {
      var subtitle = document.createElement('div');
      subtitle.className = 'product-builder__review-item-subtitle';
      subtitle.textContent = item.subtitle;
      details.appendChild(subtitle);
    }

    if (item.slotLabel) {
      var badge = document.createElement('div');
      badge.className = 'product-builder__review-item-badge';
      badge.textContent = item.slotLabel;
      details.appendChild(badge);
    }

    li.appendChild(details);

    var price = document.createElement('div');
    price.className = 'product-builder__review-item-price';

    if (item.isComplementary) {
      var original = document.createElement('s');
      original.className = 'product-builder__review-item-price-original';
      original.textContent = formatMoney(item.price, this.data.money_format);

      var free = document.createElement('span');
      free.className = 'product-builder__review-item-price-free';
      free.textContent = this.getComplementaryLabel();

      price.appendChild(original);
      price.appendChild(free);
    } else {
      price.textContent = formatMoney(item.price, this.data.money_format);
    }

    li.appendChild(price);

    return li;
  };

  ProductBuilder.prototype.getProductFormVariantSelect = function () {
    return document.querySelector('#productForm [data-product-select]');
  };

  ProductBuilder.prototype.syncProductPageVariant = function (variant) {
    if (!variant) return;

    var masterSelect = this.getProductFormVariantSelect();
    if (masterSelect) {
      masterSelect.value = String(variant.id);
    }

    var section = document.querySelector('[data-section-type="product"]');
    var optionSelectors = section
      ? section.querySelectorAll('[data-single-option-selector]')
      : [];

    if (!optionSelectors.length) {
      this.updateVariantUrl(variant.id);
      return;
    }

    optionSelectors.forEach(function (el) {
      var index = el.dataset.index;
      if (!index || index.indexOf('option') !== 0) return;

      var pos = index.replace('option', '');
      var value = variant['option' + pos];
      if (!value) return;

      if (el.type === 'radio' || el.type === 'checkbox') {
        el.checked = el.value === value;
      } else {
        el.value = value;
      }
    });

    var trigger = optionSelectors[0];
    if (typeof jQuery !== 'undefined') {
      jQuery(trigger).trigger('change');
    } else if (trigger) {
      trigger.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      this.updateVariantUrl(variant.id);
    }
  };

  ProductBuilder.prototype.updateVariantUrl = function (variantId) {
    if (!window.history.replaceState || !variantId) return;
    var newurl = window.location.protocol + '//' + window.location.host
      + window.location.pathname + '?variant=' + variantId;
    window.history.replaceState({ path: newurl }, '', newurl);
  };

  ProductBuilder.prototype.syncVariantFromProductForm = function () {
    var masterSelect = this.getProductFormVariantSelect();
    if (masterSelect && masterSelect.value) {
      var variantId = Number(masterSelect.value);
      var live = this.findVariantSnapshot(variantId) || { id: variantId };
      this.applyBaseVariantFromLive(live);
      this.updateLaunchButton();
      return;
    }

    this.syncVariantFromOptionSelectors();
  };

  ProductBuilder.prototype.getLetterFromVariant = function (variant, options) {
    if (options && options.length) {
      for (var i = 0; i < options.length; i++) {
        if (/letter/i.test(options[i])) {
          return variant['option' + (i + 1)] || variant.title;
        }
      }
    }
    return variant.title;
  };

  ProductBuilder.prototype.getCharmProductHandles = function () {
    var handles = [];
    var seen = {};

    this.charmGroups.forEach(function (group) {
      var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

      if (groupType === 'products' && group.products) {
        group.products.forEach(function (product) {
          if (product.product_handle && !seen[product.product_handle]) {
            seen[product.product_handle] = true;
            handles.push(product.product_handle);
          }
        });
      } else if (group.product_handle && !seen[group.product_handle]) {
        seen[group.product_handle] = true;
        handles.push(group.product_handle);
      }
    });

    return handles;
  };

  ProductBuilder.prototype.applyLiveVariantStock = function (variant, live) {
    this.syncVariantInventory(variant, live, {});
  };

  ProductBuilder.prototype.validateSelectedCharmStock = function () {
    var counts = {};

    this.getSelectedCharmsList().forEach(function (charm) {
      var id = String(charm.id);
      counts[id] = (counts[id] || 0) + 1;
    });

    for (var variantId in counts) {
      var tile = this.getCharmVariant(variantId);
      if (!tile) continue;

      if (!this.isVariantPurchasable(tile)) {
        return '"' + (tile.label || tile.letter) + '" is no longer available.';
      }

      var cap = this.getVariantStockCap(tile);
      if (cap !== null && counts[variantId] > cap) {
        var label = tile.label || tile.letter;
        return cap === 1
          ? 'Only 1 "' + label + '" is available.'
          : 'Only ' + cap + ' "' + label + '" charms are available.';
      }
    }

    return '';
  };

  ProductBuilder.prototype.applyLiveProductToGroup = function (group, product) {
    var self = this;
    var groupType = group.type || (group.products && group.products.length ? 'products' : 'letter');

    if (groupType === 'products' && group.products) {
      group.products.forEach(function (entry) {
        if (entry.product_handle !== product.handle) return;

        if (!entry.product_title) {
          entry.product_title = product.title;
        }

        var variantEntry = self.buildCharmProductVariantEntry(product, entry);
        if (!variantEntry) return;

        if (!entry.preview_image && variantEntry.preview_image) {
          entry.preview_image = variantEntry.preview_image;
        }

        if (!entry.preview_image_blank) {
          entry.preview_image_blank = self.resolveBlankPreviewImage(product, entry);
        }

        entry.gallery_images = self.getProductGalleryImages(product, entry);
        entry.variants = [variantEntry];
      });
      return;
    }

    if (group.product_handle !== product.handle) return;

    if (!group.product_title) {
      group.product_title = product.title;
    }

    if (!group.variants || !group.variants.length) {
      group.variants = (product.variants || []).map(function (v) {
        var letter = self.getLetterFromVariant(v, product.options);
        return {
          id: v.id,
          letter: letter,
          title: v.title,
          price: v.price,
          available: v.available,
          inventory_quantity: v.inventory_quantity,
          inventory_management: v.inventory_management || null,
          inventory_policy: v.inventory_policy || 'deny',
          preview_image: self.getVariantPreviewImage(v, product),
          sku: v.sku,
          design_token: letter
        };
      });
      return;
    }

    var variantMap = {};
    (product.variants || []).forEach(function (v) {
      variantMap[v.id] = v;
    });

    group.variants.forEach(function (variant) {
      var live = variantMap[variant.id];
      if (!live) return;
      self.applyLiveVariantStock(variant, live);
      if (!variant.preview_image) {
        variant.preview_image = self.getVariantPreviewImage(live, product);
      }
    });
  };

  ProductBuilder.prototype.refreshBaseVariantStock = function () {
    var self = this;
    var handle = this.data.base && this.data.base.handle;

    if (!handle) return Promise.resolve();

    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found: ' + handle);
        return res.json();
      })
      .then(function (product) {
        var live = (product.variants || []).find(function (variant) {
          return Number(variant.id) === Number(self.baseVariantId);
        });

        if (live) {
          self.applyBaseVariantFromLive(live);
        }
      })
      .catch(function (err) {
        console.warn('[ProductBuilder] Could not refresh base stock for ' + handle, err);
      });
  };

  ProductBuilder.prototype.enrichCharmStock = function () {
    var self = this;
    var handles = this.getCharmProductHandles();

    if (!handles.length) {
      this.syncCharmTiles();
      return Promise.resolve();
    }

    return Promise.all(handles.map(function (handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) throw new Error('Product not found: ' + handle);
          return res.json();
        })
        .then(function (product) {
          self.charmGroups.forEach(function (group) {
            self.applyLiveProductToGroup(group, product);
          });
        })
        .catch(function (err) {
          console.warn('[ProductBuilder] Could not refresh charm stock for ' + handle, err);
        });
    })).then(function () {
      self.syncCharmTiles();
    });
  };

  ProductBuilder.prototype.getCartExtras = function () {
    if (this.data && Array.isArray(this.data.cart_extras) && this.data.cart_extras.length) {
      return this.data.cart_extras;
    }
    var extras = this.config && this.config.cart_extras;
    return Array.isArray(extras) ? extras : [];
  };

  ProductBuilder.prototype.getCartExtraQuantity = function (extra) {
    if (!extra) return 0;
    if (extra.quantity_per_charm === true || extra.quantity === 'per_charm') {
      return this.getSelectedCharmCount();
    }
    return Math.max(1, parseInt(extra.quantity, 10) || 1);
  };

  ProductBuilder.prototype.getCartExtraUnitPrice = function (extra) {
    if (!extra) return 0;
    var price = Number(extra.price);
    return isNaN(price) ? 0 : price;
  };

  ProductBuilder.prototype.getBaseVariantOptionValue = function (optionName) {
    var base = this.getBaseVariant();
    if (!base || !optionName) return '';

    var options = (this.data.base && this.data.base.options) || [];
    var target = String(optionName).trim().toLowerCase();

    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      var name = (opt.name || '').trim().toLowerCase();
      if (name !== target) continue;

      var position = opt.position || (i + 1);
      if (position === 1) return base.option1 || '';
      if (position === 2) return base.option2 || '';
      if (position === 3) return base.option3 || '';
    }

    return '';
  };

  ProductBuilder.prototype.resolveCartExtraVariantId = function (extra) {
    if (!extra) return null;

    if (extra.variant_id !== null && extra.variant_id !== undefined && extra.variant_id !== '') {
      var staticId = Number(extra.variant_id);
      if (staticId && staticId > 0) return staticId;
    }

    if (!extra.resolve_from_base_option || !extra.variants || typeof extra.variants !== 'object') {
      return null;
    }

    var optionValue = this.getBaseVariantOptionValue(extra.resolve_from_base_option);
    if (!optionValue) {
      console.warn(
        '[ProductBuilder] cart_extras.' + (extra.role || 'extra')
          + ' skipped: could not read base option "' + extra.resolve_from_base_option + '"'
      );
      return null;
    }

    var variantId = extra.variants[optionValue];
    if (variantId === undefined || variantId === null || variantId === '') {
      var normalized = String(optionValue).trim().toLowerCase();
      Object.keys(extra.variants).forEach(function (key) {
        if (String(key).trim().toLowerCase() === normalized) {
          variantId = extra.variants[key];
        }
      });
    }

    var resolved = Number(variantId);
    if (resolved && resolved > 0) return resolved;

    console.warn(
      '[ProductBuilder] cart_extras.' + (extra.role || 'extra')
        + ' skipped: no cord variant mapped for "' + optionValue + '"'
    );
    return null;
  };

  ProductBuilder.prototype.buildCartExtraItems = function (builderId, design) {
    var self = this;
    var items = [];

    this.getCartExtras().forEach(function (extra) {
      var variantId = self.resolveCartExtraVariantId(extra);
      if (!variantId) {
        if (extra && extra.role) {
          console.warn('[ProductBuilder] cart_extras.' + extra.role + ' skipped: set variant_id or variants map in builder config');
        }
        return;
      }

      var quantity = self.getCartExtraQuantity(extra);
      if (quantity < 1) return;

      var role = extra.role || 'extra';

      items.push({
        id: variantId,
        quantity: quantity,
        properties: {
          '_builder_id': builderId,
          '_builder_role': role,
          '_Design': design,
          '_fulfillment': 'true'
        }
      });
    });

    return items;
  };

  ProductBuilder.prototype.addToCart = function () {
    var self = this;
    var base = this.getBaseVariant();
    if (!base || !this.isVariantPurchasable(base)) return;
    this.flushCharmSelectorInput();
    if (!this.validateMinCharms()) return;

    var btn = this.els.addToBagBtn;
    var addToBagLabel = this.config.cta && this.config.cta.add_to_bag
      ? this.config.cta.add_to_bag
      : 'Add to bag';
    setAddToBagButtonLoading(btn, true, addToBagLabel);

    this.refreshCharmCatalog().then(function () {
      return self.refreshBaseVariantStock();
    }).then(function () {
      base = self.getBaseVariant();
      if (!base || !self.isVariantPurchasable(base)) {
        setAddToBagButtonLoading(btn, false, addToBagLabel);
        alert('This product is no longer available.');
        return;
      }

      var stockError = self.validateSelectedCharmStock();
      if (stockError) {
        setAddToBagButtonLoading(btn, false, addToBagLabel);
        alert(stockError);
        self.renderCharmGrid();
        return;
      }

      if (!self.builderId) {
        self.builderId = generateBuilderId();
      }

      var design = self.getDesignLabel();
      var queue = [];

      queue.push({
        id: Number(base.id),
        quantity: 1,
        properties: {
          '_builder_id': self.builderId,
          '_builder_role': 'base',
          'Charms': design
        }
      });

      self.forEachSelectedCharm(function (charm, slotIndex, sequence) {
        var properties = {
          '_builder_id': self.builderId,
          '_builder_role': 'charm',
          '_position': String(sequence + 1),
          '_slot': String(slotIndex + 1),
          '_Design': design
        };

        if (self.hasSlotGroups()) {
          properties.Slot = self.getSlotPlacementLabel(slotIndex);
        }

        if (charm.charmType === 'letter') {
          properties._Letter = charm.letter;
        } else {
          properties._Charm = charm.label || charm.letter;
        }

        if (charm.engraving && charm.engraving.enabled) {
          properties.Letters = charm.engraving.letters;
          properties['Engraving Option'] = charm.engraving.option || 'Letters';
          properties.Engraved = 'Yes';
        }

        if (self.isComplementaryCharmIndex(sequence)) {
          properties['_complementary'] = 'true';
          properties['_Complementary'] = self.getComplementaryLabel();
        }

        queue.push({
          id: Number(charm.id),
          quantity: 1,
          properties: properties
        });
      });

      var extraItems = self.buildCartExtraItems(self.builderId, design);
      if (extraItems.length) {
        queue = queue.concat(extraItems);
      }

      self.bulkAddToCart(queue, function (success) {
        setAddToBagButtonLoading(btn, false, addToBagLabel);

        if (success) {
          self.setStep('product');
          self.selectedCharms = self.hasSlotGroups() ? self.createEmptySlotStorage() : [];
          self.previewCharmStates = {};
          self.builderId = null;
          self.renderCharmGrid();
          self.renderPreview();
        }
      });
    });
  };

  ProductBuilder.prototype.parseCartError = function (response, fallback, item) {
    if (!response) return fallback;
    if (typeof response === 'string') return response;

    var message = response.description || response.message || fallback;
    if (item && item.id) {
      message += ' (variant ' + item.id + ')';
    }
    return message;
  };

  ProductBuilder.prototype.addCartItemsSequentially = function (items, onComplete) {
    var self = this;
    var index = 0;

    function addNext() {
      if (index >= items.length) {
        self.openCartDrawer(function () {
          onComplete(true);
        });
        return;
      }

      var item = items[index];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          id: item.id,
          quantity: item.quantity || 1,
          properties: item.properties || {}
        })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            return { ok: res.ok, status: res.status, data: data, item: item };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            var message = self.parseCartError(
              result.data,
              'Could not add to bag. Please try again.',
              result.item
            );
            console.error('[ProductBuilder] Cart add failed', result.status, result.data, result.item);
            alert(message);
            onComplete(false);
            return;
          }

          index += 1;
          addNext();
        })
        .catch(function (err) {
          console.error('[ProductBuilder] Cart add failed', err, item);
          alert('Could not add to bag. Please try again.');
          onComplete(false);
        });
    }

    addNext();
  };

  ProductBuilder.prototype.bulkAddToCart = function (items, onComplete) {
    var self = this;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, status: res.status, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          console.warn('[ProductBuilder] Bulk cart add failed, retrying sequentially', result.status, result.data);
          self.addCartItemsSequentially(items, onComplete);
          return;
        }

        self.openCartDrawer(function () {
          onComplete(true);
        });
      })
      .catch(function (err) {
        console.error('[ProductBuilder] Bulk cart add failed', err);
        self.addCartItemsSequentially(items, onComplete);
      });
  };

  ProductBuilder.prototype.openCartDrawer = function (onDone) {
    var openDrawer = function () {
      setTimeout(function () {
        if (window.jQuery) {
          jQuery('html').addClass('minicart-open');
        } else {
          document.documentElement.classList.add('minicart-open');
        }
        if (onDone) onDone();
      }, 350);
    };

    var syncCart = function (cart) {
      if (window.jQuery) {
        jQuery(document).trigger('cart.requestComplete', [cart]);
      }
      openDrawer();
    };

    if (window.jQuery && typeof CartJS !== 'undefined' && CartJS.getCart) {
      CartJS.getCart({
        success: function (cart) {
          syncCart(cart);
        },
        error: function () {
          jQuery.getJSON('/cart.js', syncCart);
        }
      });
      return;
    }

    if (window.jQuery) {
      jQuery.getJSON('/cart.js', syncCart);
      return;
    }

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(syncCart)
      .catch(openDrawer);
  };

  ProductBuilder.prototype.bindImageProtection = function () {
    this.handleImageContextMenu = function (event) {
      if (event.target.closest('input, textarea, [contenteditable="true"]')) return;

      if (event.target.closest(
        '.product-builder__canvas, .product-builder__preview-zoom-canvas, .product-builder__charm-tile, .product-builder__selected-charm, .product-builder__drag-clone'
      )) {
        event.preventDefault();
      }
    };

    this.root.addEventListener('contextmenu', this.handleImageContextMenu);
  };

  ProductBuilder.prototype.bindEvents = function () {
    var self = this;

    if (this.els.launch) {
      this.els.launch.addEventListener('click', function () {
        self.syncVariantFromProductForm();
        if (!self.isBaseVariantAvailable()) return;
        self.resetBuilderSelection();
        self.activePreviewLayout = null;
        self.builderId = generateBuilderId();
        self.updateBasePreview();
        self.refreshCharmCatalog().then(function () {
          self.renderCharmGrid();
          self.syncCharmSelectorInputFromSelection();
          self.setStep('choose');
        });
      });
    }

    var masterSelect = this.getProductFormVariantSelect();
    if (masterSelect) {
      masterSelect.addEventListener('change', function () {
        var liveVariant = (window.variants || []).find(function (variant) {
          return Number(variant.id) === Number(masterSelect.value);
        });
        if (liveVariant) {
          self.applyBaseVariantFromLive(liveVariant);
        } else {
          self.syncVariantFromProductForm();
        }
        self.updateLaunchButton();
        if (self.step !== 'product') {
          self.renderPreview();
        }
      });
    }

    var productSection = document.querySelector('[data-section-type="product"]');
    if (productSection) {
      productSection.addEventListener('change', function (event) {
        if (!event.target.matches('[data-single-option-selector]')) return;
        self.syncVariantFromOptionSelectors();
        self.updateLaunchButton();
      });
    }

    if (this.els.backBtn) {
      this.els.backBtn.addEventListener('click', function () {
        if (self.step === 'review') {
          self.setStep('choose');
        } else {
          self.resetBuilderSelection();
          self.setStep('product');
        }
      });
    }

    if (this.els.reviewBtn) {
      this.els.reviewBtn.addEventListener('click', function () {
        self.flushCharmSelectorInput();
        if (!self.validateMinCharms()) return;
        self.setStep('review');
      });
    }

    if (this.els.addToBagBtn) {
      this.els.addToBagBtn.addEventListener('click', function () {
        self.addToCart();
      });
    }

    if (this.els.editBtn) {
      this.els.editBtn.addEventListener('click', function () {
        self.flushCharmSelectorInput();
        self.openEditDrawer();
      });
      this.els.editBtn.addEventListener('animationend', function (event) {
        if (event.animationName === 'product-builder-edit-btn-enter') {
          self.els.editBtn.classList.remove('is-entering');
        }
      });
    }

    if (this.els.charmsLayer) {
      this.els.charmsLayer.addEventListener('click', function (event) {
        if (self.step !== 'choose') return;
        if (!event.target || !event.target.classList.contains('product-builder__charm-on-canvas')) return;
        if (!self.getSelectedCharmCount()) return;
        self.flushCharmSelectorInput();
        self.openEditDrawer();
      });
    }

    if (this.els.previewZoomOpenBtn) {
      this.els.previewZoomOpenBtn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        self.openPreviewZoom();
      });
    }

    if (this.els.previewLayoutSwitch) {
      this.els.previewLayoutSwitch.addEventListener('click', function (event) {
        event.preventDefault();
        var layoutId = self.getAlternatePreviewLayout();
        if (!layoutId) return;
        self.setPreviewLayout(layoutId);
      });
    }

    if (this.els.previewZoomCloseBtns && this.els.previewZoomCloseBtns.length) {
      this.els.previewZoomCloseBtns.forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.preventDefault();
          self.closePreviewZoom();
        });
      });
    }

    this.handlePreviewZoomKeydown = function (event) {
      if (event.key === 'Escape' && self.previewZoomOpen) {
        self.closePreviewZoom();
      }
    };
    document.addEventListener('keydown', this.handlePreviewZoomKeydown);
    this.bindPreviewZoomGestures();

    if (this.els.closeEdit) {
      this.els.closeEdit.addEventListener('click', function () {
        self.syncCharmSelectorInputFromSelection();
        self.setStep('choose');
      });
    }

    if (this.els.editBackdrop) {
      this.els.editBackdrop.addEventListener('click', function () {
        self.syncCharmSelectorInputFromSelection();
        self.setStep('choose');
      });
    }

    if (this.els.saveEdit) {
      this.els.saveEdit.addEventListener('click', function () {
        self.renderCharmGrid();
        self.syncCharmSelectorInputFromSelection();
        self.setStep('choose');
      });
    }

    if (this.els.closeEngrave) {
      this.els.closeEngrave.addEventListener('click', function () {
        self.closeCharmEngravingPanel();
      });
    }

    if (this.els.engraveBackdrop) {
      this.els.engraveBackdrop.addEventListener('click', function () {
        self.closeCharmEngravingPanel();
      });
    }

    if (this.els.engraveSkip) {
      this.els.engraveSkip.addEventListener('click', function () {
        self.confirmCharmEngraving(false);
      });
    }

    if (this.els.engraveConfirm) {
      this.els.engraveConfirm.addEventListener('click', function () {
        self.confirmCharmEngraving(true);
      });
    }

    if (this.els.engraveInput) {
      this.els.engraveInput.addEventListener('input', function () {
        if (!self.pendingEngraveTile) return;

        var config = self.getCharmEngravingConfig(self.pendingEngraveTile) || {};
        var maxLetters = parsePositiveInt(config.max_letters);
        if (maxLetters === null) maxLetters = 3;
        var normalized = self.normalizeEngravingLetters(self.els.engraveInput.value, maxLetters);

        if (self.els.engraveInput.value !== normalized) {
          self.els.engraveInput.value = normalized;
        }

        self.showEngraveError('');
      });

      this.els.engraveInput.addEventListener('keydown', function (event) {
        if (event.key === 'Enter') {
          event.preventDefault();
          self.confirmCharmEngraving(true);
        }
      });
    }

    if (this.els.startOrder) {
      this.els.startOrder.addEventListener('click', function () {
        self.startOver();
      });
    }

    if (this.els.bespokeCharmsToggle) {
      this.els.bespokeCharmsToggle.addEventListener('click', function () {
        if (!self.els.bespokeCharmsMessage) return;

        var isOpen = !self.els.bespokeCharmsMessage.hidden;
        self.els.bespokeCharmsMessage.hidden = isOpen;
        self.els.bespokeCharmsToggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    }

    window.addEventListener('resize', function () {
      self.applyPreviewAppearance();
      self.renderPreview();
      self.syncEngraveGalleryLayout();
    });
  };

  ProductBuilder.prototype.ensureLaunchVisible = function () {
    this.updateLaunchButton();
  };

  ProductBuilder.prototype.init = function () {
    if (!this.data || !this.data.config) {
      console.warn('[ProductBuilder] Missing config');
      return;
    }

    var self = this;
    this.ensureBuilderPortal();
    this.bindEvents();
    this.bindCharmSelectorInput();
    this.bindImageProtection();

    if (this.els.baseImage) {
      configureBuilderImage(this.els.baseImage);
    }
    if (this.els.previewLayoutThumbA) {
      configureBuilderImage(this.els.previewLayoutThumbA);
    }
    if (this.els.previewLayoutThumbB) {
      configureBuilderImage(this.els.previewLayoutThumbB);
    }
    this.syncVariantFromProductForm();
    this.updateLaunchButton();
    this.updatePreviewZoomButtonVisibility();
    this.renderPreviewLayoutToggle();
    this.normalizeCharmGroups();
    this.applyPreviewAppearance();
    this.syncCharmSelectorInputUI();
    this.preloadBaseImagesByCount();

    var productContainer = document.querySelector('[data-section-type="product"]');
    if (productContainer && typeof jQuery !== 'undefined') {
      jQuery(productContainer).on('variantChange', function (event) {
        var variant = event.variant;
        if (variant) {
          self.applyBaseVariantFromLive(variant);
        } else {
          self.syncVariantFromOptionSelectors();
        }
        self.updateLaunchButton();
        if (self.step !== 'product') {
          self.renderPreview();
        }
      });
    }

    this.refreshCharmCatalog().then(function () {
      self.renderCharmGrid();
      self.updateRunningTotal();

      if (!self.charmTiles.length) {
        console.warn('[ProductBuilder] No charm tiles available after loading product data');
      }
    });
  };

  ready(function () {
    var root = document.getElementById('product-builder');
    if (!root) return;

    var data = parseBootstrap();
    if (!data) return;

    var builder = new ProductBuilder(root, data);
    window.__productBuilder = builder;
    builder.init();
  });
})();
